function TargetDate()
{
	var self 				= this;
	var tl 					= new TimelineMax();
	self.isFullscreen 		= false;
	self.targetDate 		= $('#target-date');
	self.csvData			= [];
	self.csvSelectionData	= [];
	self.enableQ3			= true;
	self.magnifiedPoints 	= [];
	self.putnamFundIds 		= [];
	self.highlightedFunds 	= [];
	self.checkedFunds		= [];
	self.checkedFundLimit 	= 5;
	self.checkedFundMin 	= 2;
	self.hoveringFund 		= undefined;
	self.filteredFunds 		= {};
	self.industryAverage 	= {};
	self.filter 			= {
		x: {
			min:0,
			max:100
		},
		y: {
			min:0,
			max:100
		},
		funds: {
			/*cit:false,
			mutualFund:false,
			to:false,
			thru:false*/
		}
	};

	// Viewport state parameters to animate and filter
	var STATE = {
		DEFAULT: {
			string: 'funds-chart-all',
			options: {
				height: '100%',
				width: '100%',
				left: 0
			},
			filter: {
				x: {
					min:0,
					max:100
				},
				y: {
					min:0,
					max:100
				}
			},
			axisX: '50%',
			axisY: '50%'
		},
		TOP: {
			string: 'funds-chart-tp',
			options: {
				height: '200%'
			},
			filter: {
				x: {
					min:0,
					max:100
				},
				y: {
					min:50,
					max:100
				}
			}
		},
		BOTTOM: {
			string: 'funds-chart-bt',
			options: {
				height: '200%',
				top: '-100%'
			},
			filter: {
				x: {
					min:0,
					max:100
				},
				y: {
					min:0,
					max:50
				}
			}
		},
		LEFT: {
			string: 'funds-chart-lt',
			options: {
				width: '200%'
			},
			filter: {
				x: {
					min: 0,
					max: 50
				},
				y: {
					min: 0,
					max: 100
				}
			}
		},
		RIGHT: {
			string: 'funds-chart-rt',
			options: {
				width: '200%',
				left: '-100%'
			},
			filter: {
				x: {
					min: 50,
					max: 100
				},
				y: {
					min: 0,
					max: 100
				}
			}
		},
		TOP_LEFT: {
			string: 'funds-chart-tl',
			options: {
				height: '200%',
				width: '200%'
			},
			filter: {
				x: {
					min:0,
					max:50
				},
				y: {
					min:50,
					max:100
				}
			}
		},
		TOP_RIGHT: {
			string: 'funds-chart-tr',
			options: {
				height: '200%',
				width: '200%',
				left: '-100%'
			},
			filter: {
				x: {
					min:50,
					max:100
				},
				y: {
					min:50,
					max:100
				}
			}
		},
		BOTTOM_LEFT: {
			string: 'funds-chart-bl',
			options: {
				height: '200%',
				width: '200%',
				top: '-100%'
			},
			filter: {
				x: {
					min:0,
					max:50
				},
				y: {
					min:0,
					max:50
				}
			}
		},
		BOTTOM_RIGHT: {
			string: 'funds-chart-br',
			options: {
				height: '200%',
				width: '200%',
				left: '-100%',
				top: '-100%'
			},
			filter: {
				x: {
					min:50,
					max:100
				},
				y: {
					min:0,
					max:50
				}
			}
		}
	};
	self.currentState = STATE.DEFAULT;
	
	// Cached elements
	var el 					= {
		document: 		$(document),
		dataContainer: 	self.targetDate.find('.container-data'),
		magnify: {
			container: self.targetDate.find('.magnify'),
			svg: self.targetDate.find('.magnify svg'),
			// Position in percent from 0-1
			lines:[
				{ axis:'x', position:0 },
				{ axis:'y', position:0 },
				{ axis:'x', position:1 },
				{ axis:'y', position:1 },
				{ axis:'x', position:parseInt(STATE.DEFAULT.axisX)/100 },
				{ axis:'y', position:parseInt(STATE.DEFAULT.axisY)/100 }
			]
		},
		axis: {
			x: self.targetDate.find('.axis-x'),
			y: self.targetDate.find('.axis-y')
		},
		labels: {
			x:self.targetDate.find('.labels-axis.x'),
			y:self.targetDate.find('.labels-axis.y'),
			arrows: {
				x: {
					aggressive: self.targetDate.find('.labels-axis-title .label.x .arrow-aggressive'),
					conservative: self.targetDate.find('.labels-axis-title .label.x .arrow-conservative')
				},
				y: {
					aggressive: self.targetDate.find('.labels-axis-title .label.y .arrow-aggressive'),
					conservative: self.targetDate.find('.labels-axis-title .label.y .arrow-conservative')
				}
			}
		},
		keyHighlight: 			$('#key-box .highlight'),

		answers: 				$('#questions .options'),

		infoModal: 				$('#info-modal'),
		debugModal: 			$('#debug-modal'),
		putnamHighlightsModal:	$('#putnam-highlights-modal'),
		strategyOtherModal:		$('#putnam-strategy-other'),
		submissionModal:		$('#submission-modal'),
		infoButton: 			$('#info'),
		resetButton: 			$('#reset'),
		fundList:	 			$('#fund-list'),
		fundListForm: 			$('#fund-list form'),
		fundListButton: 		$('#show-funds'),
		requestFundButtons:		$('.request-funds'),
		highlightPutnamFundsButton:	$('#highlightPutnamFunds'),
		highlightPutnamFundsButtonCheck : $('#highlightPutnamFundsCheck'),
		nextButton: 			$('#next'),
		nextSubmitButton:		$('#next-submit'),
		backButton: 			$('#back'),
		// startOverButton:		$('#start-over'),
		skipButton: 			$('#skip'),
		downloadButton:			$('#download-report'),

		fundFilters: 			$('#filter-modal .filter-checkbox'),

		fundDetailModal:		$('#fund-detail-modal'),
		// analysisModal:			$('#analysis-modal'),
		analysisChart:			$('#analysis-chart'),

		analysisFormWrapper:	$('#analysis'),
		analysisCustomize:		$('#customize-report'),
		analysisForm: 			$('#analysis-form'),
		analysisFunds:			$('#analysis-funds'),
		analysisManager:		$('#analysis-manager'),
		analysisManagerSelect: 	$('#analysis-manager-select'),
		analysisSubmit: 		$('#analysis-submit'),
		submissionLoadBar : 	$('#submission-load-bar'),

		attrDataFunds: 			$('[data-funds]'),
		attrDataSelectedFunds: 	$('[data-selected-funds]'),

		svg: {
			triangle: '<svg class="symbol" viewBox="0 0 100 100"><polygon points="50 0, 0 100, 100 100" fill /></svg>',
			triangleDown: '<svg class="symbol" viewBox="0 0 100 100"><polygon points="0 0, 50 100, 100 0" fill /></svg>',
			diamond: '<svg class="symbol" viewBox="0 0 100 100"><polygon points="50 0, 0 50, 50 100, 100 50" fill /></svg>'
		},
		tooltip:undefined
	};

	// Stored fund parameters from CSV
	var FUND_PARAMS 		= {
		NAME: "Strategy_Name",
		DESCRIPTION: "description",
		FUND_ID: "fund_id",
		DB_ID: "db_id",
		PATH_TYPE: "Glide_Path_Type",
		INCEPTION: "inception_date",
		MGR_TENURE: "avg_manager_tenure",
		SUM_ASSETS: "sum_assets",
		CIT: "is_CIT",
		X2020: "X2020_equity_percentile",
		X2055: "X2055_equity_percentile",
		FARTHEST_PERCENTILE: "std_percentile_farthest_from_retire",// Used to be "equity_percentile_farthest_to_retire"
		CLOSEST_PERCENTILE: "std_percentile_closest_to_retire",// Used to be "equity_percentile_closest_to_retire"
		// Custom
		ID: "ID",
		X_POSITION: "xPos",
		Y_POSITION: "yPos",
		GLIDE_PATH: [
			'stated_equity_allocation_50_pre',
			'stated_equity_allocation_45_pre',
			'stated_equity_allocation_40_pre',
			'stated_equity_allocation_35_pre',
			'stated_equity_allocation_30_pre',
			'stated_equity_allocation_25_pre',
			'stated_equity_allocation_20_pre',
			'stated_equity_allocation_15_pre',
			'stated_equity_allocation_10_pre',
			'stated_equity_allocation_5_pre',
			'stated_equity_allocation_0',
			'stated_equity_allocation_5_post',
			'stated_equity_allocation_10_post',
			'stated_equity_allocation_15_post',
			'stated_equity_allocation_20_post',
			'stated_equity_allocation_25_post',
			'stated_equity_allocation_30_post'
		],
		CATEGORIES: 	[50,45,40,35,30,25,20,15,10,5,{y:0, id:'retirement'},5,10,15,20,25,30],
		SERIES_COLORS: 	['#007cc6','#0093c1','#1aa5b1','#67b3a3','#9bbfa0','#c3c9ad'],
		SERIES_MARKERS:	['circle', 'triangle', 'square', 'diamond', 'triangle-down', 'circle']
	};

	var requestParams = {
		// url: "https://www-dev.putnam.com/dcio/get-pdf/", // Old URL no longer in use
		tokenUrl: "/dcio/targetdatemarkovpdf/startpdfprocess",
		pdfStatusUrl: "/dcio/targetdatemarkovpdf/pdfstatus",
		pdfGetUrl: "/dcio/targetdatemarkovpdf/getpdffile",
		currentToken: '',
		pdfReceived: false,
		highestYear: 2020, // Opposite to allow for scaling
		lowestYear: 2050, // Opposite to allow for scaling
		oldestFundYear: 2025, // Oldest vintage fund year allowed
		youngestFundYear: 2055, // Youngest vintage fund year allowed
		json: {
			"needToJoin": true,
			"saveFile": true,
			"aws3": true,
			"sqsName": "StylusPutnamSendScript.fifo",
			"scriptcode": ""
		}
	}
	var pdfSubmissionInterval;

	var params = {};

	// Fisheye calculations
	var fisheye = {
		circular: function() {
			var radius = 200,
				distortion = 2,
				k0,
				k1,
				focus = [0, 0];

			function fisheye(d) {
				var dx = d.x - focus[0],
					dy = d.y - focus[1],
					dd = Math.sqrt(dx * dx + dy * dy);
				if (!dd || dd >= radius) return {x: d.x, y: d.y, z: dd >= radius ? 1 : 10};
				var k = k0 * (1 - Math.exp(-dd * k1)) / dd * 0.75 + 0.25;
				return {x: focus[0] + dx * k, y: focus[1] + dy * k, z: Math.min(k, 10)};
			}

			function rescale() {
				k0 = Math.exp(distortion);
				k0 = k0 / (k0 - 1) * radius;
				k1 = distortion / radius;
				return fisheye;
			}

			fisheye.radius = function(_) {
				if (!arguments.length) return radius;
				radius = +_;
				return rescale();
			};

			fisheye.distortion = function(_) {
				if (!arguments.length) return distortion;
				distortion = +_;
				return rescale();
			};

			fisheye.focus = function(_) {
				if (!arguments.length) return focus;
				focus = _;
				return fisheye;
			};

			return rescale();
		}
	}
	var magnifyRadius 	= 125; // Threshold to start applying fisheye
	var magnifyDiameter = magnifyRadius * 2;
	var magnifyWindow 	= fisheye.circular().radius(magnifyRadius).distortion(2.75);
	
	self.ready = function() {

		// Hide footer disclosure if query string ?footer=false
		var query = parseQueryString( window.location.search.substring(1) );
		if (query.footer != "false")
			document.getElementById('footer').classList.remove('d-none');

		// Store user data if loaded into form fields as data-input-default
		self.formStoreAnalysisDefaults();
		
		self.updateView();

		var dataLoaded = false;
		$.ajax({
			url: "/static/module/tdv/data/fundData16.csv?v=1",
			success: function (csvd) {
				var items = $.csv.toObjects(csvd);
				items.shift();
				self.csvData = items;
				if (dataLoaded) {
					self.checkForNullSeries();
					self.filterFunds();
				}
				self.putnamFundIds = self.getPutnamFunds();
				console.log("TDV :: ready :: Putnam funds", self.getPutnamFunds());
				dataLoaded = true;
			},
			dataType: "text"
		});
		$.ajax({
			url: "/static/module/tdv/data/share_class_selection_data_Q4_2022.csv?v=2",
			success: function (csvd) {
				var items = $.csv.toObjects(csvd);
				items.shift();
				self.csvSelectionData = items;
				if (dataLoaded) {
					self.checkForNullSeries();
					self.filterFunds();
				}
				dataLoaded = true;
			},
			dataType: "text"
		});

		// Event Handlers

		// Tooltip
		el.document.on('mouseenter mousemove mouseout mousedown', '.fund-check', function (e) {
			if (self.checkedFunds.length >= self.checkedFundLimit && e.currentTarget.firstElementChild.checked == false) {
				self.handleTooltip(e.currentTarget, e);
			}
		});
		
		// Fund list: Show/hide strategies - moved list to sidebar, and removed button
		if (el.fundListButton.length > 0) {
			el.fundList.on('show.bs.collapse hide.bs.collapse', function (e) {
				el.fundListButton[0].innerHTML = ( e.type == 'show' ) ? 'Hide strategies' : 'Show strategies';
			});
		}

		// Fund select: Update checked total on fund select change
		el.document.on('click', '.modal .fund-check input', function(e) {
			var fundID = $(this).data('fund');
			self.handleFundCheck(e, fundID);
			if ( $(this)[0].checked == true ) {
				el.fundDetailModal.modal('hide');
			}
		});
		el.fundListForm.on('click', '.fund-check', function(e) {
			var fundID = $(this).data('fund');
			if ( $(e.target).hasClass('show-fund-modal') ) {
				e.preventDefault();
				self.showFundDetails( self.getFilteredFundsByID(fundID) );
			} else {
				self.handleFundCheck(e, fundID);
			}
		});

		// Fund highlight
		el.fundListForm.on('mouseover mouseout', '.fund-check', function(e) {
			var $this = $(this),
				fundID = $this.data('fund'),
				targetFund = el.dataContainer.find('.id-'+fundID);

			if (e.type == 'mouseover') {
				targetFund.addClass('hover');
			} else {
				targetFund.removeClass('hover');
			}
		});

		// Answer select: Updated view based on selected answers
		el.answers.on('change', function(e) {
			self.handleAnswerChange(e);
		});

		// Filter
		el.fundFilters.on('change', function(e) {
			self.filter.funds[e.target.value] = e.target.checked;
			self.filterFunds();
			console.log("Filter:", self.filter.funds);
		});

		// Hover/Magnification
		el.dataContainer.on('mousemove mouseenter mouseleave', function(e) {
			self.handleHover(e);
		});

		// Hover/Magnification point click
		el.dataContainer.on('click', function(e) {
			if (self.hoveringFund != undefined) {
				self.showFundDetails(self.hoveringFund);
			}
		});

		// Reset
		el.resetButton.on('click', function (e) {
			self.reset();
		});

		// Request analysis
		el.requestFundButtons.on('click', function(e) {
			if (self.checkedFunds.length)
				self.showFundAnalysis();
		});

		// Highlight Putnam funds
		el.highlightPutnamFundsButton.on('click', function(e) {

			if( self.filteredFundsHasPutnam)
			{
				for (var i = 0; i < self.putnamFundIds.length; i++) {
					e.target.checked ? self.highlightFund(self.putnamFundIds[i]) : self.unHighlightFund(self.putnamFundIds[i]);
				}
			}
			else
			{
				e.preventDefault();
				el.putnamHighlightsModal.find('.putnam-highlights-modal-section').text( self.quadrantDescriptor );
				el.putnamHighlightsModal.modal('show');
			}
		});

		// FAQ toggle + Collapse toggle
		$('[data-toggle="modal-collapse"]').on('click', function(e){
			var targets = $(this).attr('data-target').split(',');
			var parent = $(targets[1]).attr('data-parent');
			$(targets[0]).modal('show');
			$(parent + ' .collapse').collapse('hide'); // Collapse all FAQ items
			$(targets[1]).collapse('show');
		});

		self.animate();

		if (query.debug)
			self.initDebug();
	}

	self.loaded = function() {
		el.analysisSubmit[0].addEventListener('click', function(e) {
			if (!el.analysisForm[0].checkValidity()) {
				if (el.analysisForm[0].reportValidity) {
					console.log("Check validity", el.analysisForm[0].checkValidity(), el.analysisForm[0].reportValidity());
					el.analysisForm[0].reportValidity();
				} else {
					//warn IE users
				}
			} else {
				self.submitAnalysis(el.analysisForm[0], el.analysisSubmit[0]);
			}
		});
		
		el.analysisForm.on('change keyup', 'input', function(e) {
			querySubmit();
		});

		el.analysisManager[0].addEventListener('click', function(e) {
			if( self.checkedFunds.length >= self.checkedFundLimit + 1 )
				e.preventDefault();
			else
				updateManagerSelect(e.target.checked);
		});

		// on click of analysisCustomize checkbox, show/hide analysisCustomizeForm
		el.analysisCustomize[0].addEventListener('click', function(e) {
			el.analysisForm.toggleClass('d-none');
		});
	}

	self.resize = function() {
		self.updateParams();
	}
	self.reset = function() {
		// Questions
		el.answers.each(function() {
			this.selectedIndex = 0;
		});
		// Reset view state
		self.updateState(STATE.DEFAULT);
		// Filters
		self.filter.funds = {};
		el.fundFilters.each(function(){
			this.checked = false;
		});
		self.filterFunds();
		// Fund List
		self.checkedFunds = [];
		self.updateCheckedFunds();
		el.fundList.collapse( 'hide' );
		// Highlighted funds
		self.highlightedFunds = [];
		el.highlightPutnamFundsButton[0].children[0].checked = false;
		// Reset analysis form
		self.formReset(el.analysisFormWrapper[0], false);
		if (el.analysisCustomize[0].checked) {
			el.analysisCustomize.click();
		}
		if (el.analysisManager[0].checked) {
			el.analysisManager.click();
		}

		// Reset PDF
		requestParams.pdfReceived = false;

		tl.play(1);
	}
	
	self.receiveMessage = function(e) {
		console.log('TDV :: receiveMessage :: Message received', e);
		if (e.data == 'fullscreenSuccess') {
			// Toggle fullscreen button to minimize button
			console.log("    :: receiveMessage :: Fullscreen Success");
			self.isFullscreen = true;
		} else if (e.data == 'minimizeSuccess') {
			// Toggle minimize button to fullscreen button
			console.log("    :: receiveMessage :: Minimize Success");
			self.isFullscreen = false;
		} else {
			console.log("    :: receiveMessage :: Message Error");
		}
	}

	self.sendFullscreenRequest = function () {
		console.log("TDV :: sendFullscreenRequest");
		window.parent.postMessage('requestFullscreen', '*');
	}
	self.sendMinimizeRequest = function () {
		console.log("TDV :: sendMinimizeRequest");
		window.parent.postMessage('requestMinimize', '*');
	}

	self.animate = function() {

		var textEaseIn = 'power3.inOut';
		var textEaseOut = 'power3.out';

		document.body.classList.add('gs-start');
		tl.set('.animate-start-d-none', { autoAlpha: 0, display:'none' });

		// Order of operation
		// - Fade old out
		// - Set visibility (alpha 1, display block)
		// - Add label
		// - Fade in new
		// - Add pause

		// Intro
		tl.addLabel('intro');
		tl.set('#intro', 				{ autoAlpha: 1, display:'block'});
		tl.from('#intro-text-1', 1, 	{ autoAlpha: 0, y: '+10px', ease: textEaseIn, delay: 1 }); // Intro Header
		tl.to('#skip', 1, 				{ autoAlpha: 1, display:'block' }, '-=1');
		tl.to('.fund-graph-overlay', 1,	{ backgroundImage: 'linear-gradient(225deg, rgba(255,255,255,1), rgba(255,255,255,0))' });
		tl.to('.fund-graph-overlay', 3,	{ backgroundPosition: '0% 100%' }, '-=0.5');
		
		// Fade scene one in
		tl.addLabel('scene-1');
		tl.from('#intro-text-2-1', 1, 	{ autoAlpha: 0, y: '+10px', ease: textEaseIn }, '-=2'); // Intro text 2-1 fade in
		tl.from('#intro-text-2-2', 1, 	{ autoAlpha: 0, y: '+10px', ease: textEaseIn }, '+=2'); // Intro text 2-2 fade in
		
		// Fade scene 1 out, fade scene 2 in
		tl.addLabel('scene-2', '+=8');
		tl.to(['#intro-text-2-1', '#intro-text-2-2'], 0.5, { autoAlpha: 0, y: '-10px', ease: textEaseOut }, 'scene-2'); // Intro text 2 fade out
		tl.from('#intro-text-3', 1, 			{ autoAlpha: 0, y: '+10px', ease: textEaseIn }); // Intro text 3 fade in
		tl.from('.axis', 1,					 	{ autoAlpha: 0 }); // Axis fade in
		tl.to('.container-data', 1, 			{ autoAlpha: 0.2 }, '-=1'); // Fade data points for text overlay
		tl.staggerFrom('.intro-overlay>div>div', 1, { autoAlpha: 0, stagger: 1 }); // Fade in overlay
		tl.from('#intro-text-4', 1, 			{ autoAlpha: 0, y: '+10px', ease: textEaseIn });

		// Fade scene 2 out, fade scene 3 in
		tl.staggerTo(['#intro-text-3', '#intro-text-4'], 0.5, { autoAlpha: 0, y: '-10px', ease: textEaseOut, stagger: 0.2, delay: 3 });
		tl.addLabel('scene-3');
		tl.to('#skip', 0.5, 						{ autoAlpha: 0, display: 'none' });
		tl.addCallback( queryNext, '-=0', [true] );
		tl.to(['#next', '#show-funds-box', '#highlightPutnamFunds'], 0.5, 	{ autoAlpha: 1, display: 'block' });
		tl.from('#intro-text-5', 1, 				{ autoAlpha: 0, y: '+10px', ease: textEaseIn });
		tl.from('.container-labels-axis', 1, 		{ autoAlpha: 0 });
		tl.staggerTo('.intro-overlay>div>div', 0.7, { autoAlpha: 0, stagger: 0.3 }); // Fade out overlay
		tl.to('.container-data', 1, 				{ autoAlpha: 1 });
		tl.set('.fund-graph-overlay',				{ display: 'none' });
		tl.addPause();

		// Questions
		tl.staggerTo(['#intro-text-1', '#intro-text-5'], 0.5, { autoAlpha: 0, y: '-10px', ease: textEaseOut, stagger: 0.2 });
		tl.set('#intro', { autoAlpha: 0, display: 'none' });
		tl.addCallback(queryNext);
		tl.addLabel('questions');
		tl.set(['#question-1', '#question-2'], 		{ autoAlpha: 1, display: 'block' });
		tl.from(['#question-1', '#question-2'], 1, 	{ autoAlpha: 0 });
		tl.addPause();

		// Questions 2
		tl.addLabel('questions-2');
		tl.set('#question-3', 		{ autoAlpha: 1, display: 'block' });
		tl.from('#question-3', 1, 	{ autoAlpha: 0 });
		tl.addPause();

		// Selection
		tl.to(['#question-1', '#question-2', '#question-3', '#next'], 0.5,	{ autoAlpha: 0, display: 'none' });
		tl.to(['#back', '#next-wrapper'], 0.5,{ autoAlpha: 1, display: 'block' });
		tl.set('#selection', 				{ autoAlpha: 1, display: 'block' });
		tl.addLabel('selection');
		tl.addCallback(queryNext);
		tl.staggerFrom(['#selection-text-1', '#fund-list'], 1, 	{ autoAlpha: 0, y: '+=10px', ease: textEaseIn, stagger: 1 });
		tl.addPause();

		// Analysis form
		tl.to(['#selection', '#target-date', '#chart-extras', '#next-wrapper'], 0.5, { autoAlpha: 0, display: 'none' });
		tl.addLabel('analysis');
		tl.addCallback( querySubmit );
		tl.to(['#analysis', '#analysis-chart'], 1, { autoAlpha: 1, display: 'block' });
		tl.addPause();

		// Report Submission
		// tl.to(['#analysis', '#back'], 0.5, { autoAlpha: 0, display: 'none' });
		tl.addLabel('report-submission');
		// Displays modal, and makes it non-dismissable
		tl.addCallback(() => {
			el.submissionModal.modal('show');
			el.submissionModal.data('bs.modal')._config.backdrop = 'static';
			el.submissionModal.data('bs.modal')._config.keyboard = false;
			el.submissionModal[0].querySelector('.modal-dialog').classList.add('modal-lg');
		});
		tl.to('.report-loading', 1, { autoAlpha: 1, display: 'block' });
		// Child timeline for loading animation
		tl.add( self.getLoadingAnimation({ imageSelector: '#loading-img', loadingBarSelector: '#loading-bar' }) );
		tl.addPause();

		// Report Success
		tl.to('.report-loading', 0.5, { autoAlpha: 0, display: 'none' });
		tl.addLabel('report-success');
		// Makes modal dismissable
		tl.addCallback(() => {
			el.submissionModal.data('bs.modal')._config.backdrop = true;
			el.submissionModal.data('bs.modal')._config.keyboard = true;
			el.submissionModal[0].querySelector('.modal-dialog').classList.remove('modal-lg');
		});
		tl.to(['.report-success', '#back'], 1, { autoAlpha: 1, display: 'block' });
		tl.addPause();

		// Report Error
		tl.to('.report-success', 0.5, { autoAlpha: 0, display: 'none' });
		tl.addLabel('report-error');
		tl.addCallback(() => {
			el.submissionModal[0].querySelector('.modal-dialog').classList.add('modal-lg');
		});
		tl.to(['.report-error', '#back'], 1, { autoAlpha: 1, display: 'block' });
		tl.addPause();

		el.backButton.on('click', function () {
			tl.currentLabel() == 'selection' ? tl.play('questions-2') : tl.play('selection');
			el.analysisManager[0].checked = false;
			updateManagerSelect(false);
			console.log('TDV :: Back - Play questions :: Current Label: ', tl.currentLabel());
		});
		/* el.startOverButton.on('click', function () {
			tl.play(1);
			self.reset();
			console.log('TDV :: Start Over');
		}); */
		el.skipButton.on('click', function () {
			tl.play('scene-3');
			console.log('TDV :: Skip - Play Scene 3 :: Current Label: ', tl.currentLabel());
		});
		el.nextButton.on('click', function () {
			if (tl.currentLabel() == 'questions' || tl.currentLabel() == 'questions-2') {
				tl.play('selection');				
			} else {
				tl.paused() ? tl.resume() : tl.play( tl.getLabelAfter() );
			}
			console.log('TDV :: Next :: Current Label: ', tl.currentLabel());
		});
	}

	// @function getLoadingAnimation
	// @description Creates a timeline for the loading animation
	// @param {object} args - The arguments for the function
	// 		- @param {string} imageSelector - The selector for the image to animate
	// 		- @param {string} textSelector - The selector for the text to animate (optional)
	// 		- @param {string} loadingBarSelector - The selector for the loading bar to animate (optional)
	// 		- @param {number} loopNum - The number of times to loop the animation
	// @returns {TimelineMax} - The timeline for the loading animation
	self.getLoadingAnimation = function ( args ) {
		let defaults = {
			// imageSelector: '#loading-img',
			// textSelector: '#loading-text',
			// loadingBarSelector: '#loading-bar',
			loopNum: 2
		}
		let options = { ...defaults, ...args }
		let loadingTl = new TimelineMax();

		const duration = 1.5;
		const delay = 4;
		
		const OPACITY = {
			OFF: 0,
			UNFOCUSED: 0.5,
			FOCUSED: 1
		}
		const SCALE = {
			OFF: 0.7,
			UNFOCUSED: 0.9,
			FOCUSED: 1
		}
		const X_POSITION = {
			LEFT_OFF: -100,
			LEFT: -10,
			CENTER: 100,
			RIGHT: 210,
			RIGHT_OFF: 300
		}
		const POSITIONS = [
			{ xPercent: X_POSITION.LEFT_OFF, opacity: OPACITY.OFF, scale: SCALE.OFF },
			{ xPercent: X_POSITION.LEFT, opacity: OPACITY.UNFOCUSED, scale: SCALE.UNFOCUSED },
			{ xPercent: X_POSITION.CENTER, opacity: OPACITY.FOCUSED, scale: SCALE.FOCUSED },
			{ xPercent: X_POSITION.RIGHT, opacity: OPACITY.UNFOCUSED, scale: SCALE.UNFOCUSED },
			{ xPercent: X_POSITION.RIGHT_OFF, opacity: OPACITY.OFF, scale: SCALE.OFF }
		]

		let imgElems = $(options.imageSelector).children();
		loadingTl.set(options.imageSelector, { autoAlpha: 1, display: 'block' });

		// Set each element's position based on data-position attribute
		for (let i = 0; i < imgElems.length; i++) {
			const elem = imgElems[i];
			const position = elem.dataset.position;
			// If position is greater than the number of positions, set to the last position (cues up hidden elements to be shown sequentially)
			const toPos = position > POSITIONS.length - 1 ? POSITIONS.length - 1 : position;
			loadingTl.set(elem, { xPercent: POSITIONS[toPos].xPercent, opacity: POSITIONS[toPos].opacity, scale: POSITIONS[toPos].scale });
		}

		// Enable optional text animation if text selector is defined
		if (options.textSelector != undefined) {
			var textElems = $(options.textSelector).children();
			var textNum = 0;
			loadingTl.set(options.textSelector, { autoAlpha: 1, display: 'block' });
			for (let i = 0; i < textElems.length; i++) {
				const elem = textElems[i];
				loadingTl.set(elem, { autoAlpha: 0 });
			}
		}
		// Enable optional loading bar animation if loading bar selector is defined
		if (options.loadingBarSelector != undefined) {
			var progressBarElem = $(options.loadingBarSelector).children();
			loadingTl.set(options.loadingBarSelector, { autoAlpha: 1, display: 'block' });
			loadingTl.fromTo(options.loadingBarSelector, 1, { opacity: 0 }, { opacity: 1 }, 0);
		}
		const totalTimelineLength = ( ( imgElems.length + 1 ) * (duration + delay) ) * options.loopNum;
		loadingTl.fromTo(options.imageSelector, 0.5, { opacity: 0 }, { opacity: 1 }, 0);
		for (let l = 0; l < options.loopNum; l++) {
			const progress = ( ( imgElems.length + 1 ) * (duration + delay) ) * l;
			// Create a full animation loop for each element
			for (let i = 0; i < imgElems.length + 1; i++) {
				let position = (imgElems.length + 1) * l + (i + 1); // Label position for each set of images animated
				let timelinePosition = progress + ( i * ( duration + delay ) );
				loadingTl.addLabel('position-' + position);
				// Loop through the img elements, get data-position from each, decrement the positions, and animate to the position.
				for (let j = 0; j < imgElems.length; j++) {
					const elem = imgElems[j];
					let position = elem.dataset.position - 1;
					// If position is less than 0, set to the last position (cues up hidden elements to be shown sequentially)
					if (position == -1) {
						position = imgElems.length;
						const toPos = position > POSITIONS.length - 1 ? POSITIONS.length - 1 : position;
						loadingTl.set(elem, {
							xPercent: POSITIONS[toPos].xPercent,
							opacity: POSITIONS[toPos].opacity,
							scale: POSITIONS[toPos].scale
						}, timelinePosition);
						position--;
					}
					const toPos = position > POSITIONS.length - 1 ? POSITIONS.length - 1 : position;
					loadingTl.to(elem, duration, {
						xPercent: POSITIONS[toPos].xPercent,
						opacity: POSITIONS[toPos].opacity,
						scale: POSITIONS[toPos].scale,
						ease: Power1.easeInOut
					}, timelinePosition);
					elem.dataset.position = position;
				}
				// Animate the text elements if text selector is defined
				if (options.textSelector != undefined) {
					let textElem = textElems[textNum];
					loadingTl.fromTo(textElem, 0.5, { y: 10, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, timelinePosition + 0.5);
					loadingTl.to(textElem, 0.5, { y: -10, autoAlpha: 0, ease: Power2.easeOut }, timelinePosition + 2);
					textNum = (textNum == textElems.length - 1) ? 0 : textNum + 1;
				}
				// Animate the loading bar if loading bar selector is defined - tied to the image animation
				/* if (options.loadingBarSelector != undefined) {
					loadingTl.to(progressBarElem, 1, { width: ((timelinePosition / totalTimelineLength)*100)+1 + '%', ease: Power1.easeOut }, timelinePosition + 0.5);
				} */
			}
		}
		// Animate the loading bar if loading bar selector is defined - linear animation tied to whole timeline length
		if (options.loadingBarSelector != undefined) {
			loadingTl.to(progressBarElem, totalTimelineLength, { width:'100%', ease: Power0.easeNone }, 0);
		}

		return loadingTl;
	}

	// <---- DEBUG ---->
	self.initDebug = function () {
		$('#debug').removeClass('d-none');
		$('#btn-pause').on('click', function () {
			tl.pause();
		});
		$('#btn-resume').on('click', function () {
			tl.play();
		});
		$('#btn-form').on('click', function () {
			tl.play('analysis');
		});
		$('#btn-questions').on('click', function () {
			tl.play('questions');
		});
		$('#btn-report-submission').on('click', function () {
			tl.play('report-submission');
		});
		$('#btn-report-success').on('click', function () {
			tl.play('report-success');
		});
		$('#btn-report-error').on('click', function () {
			tl.play('report-error');
		});
		
		$('#btn-user-info').on('click', function () {
			el.debugModal.modal('show');
		});

		$('#btn-assemble').on('click', function () {
			if ($('#fund-dropdown')[0]) {
				console.log("DEBUG :: Assembling with current manager value:", $('#fund-dropdown')[0].value);
				self.assembleScriptCode($('#fund-dropdown')[0].value);
			} else {
				console.log("DEBUG :: Assembling without current manager value. Select from form to test.");
				self.assembleScriptCode();
			}
		});
		$('#btn-startpdf').on('click', function () {
			requestParams.pdfReceived = false;
			if (self.checkedFunds.length == 0) {
				console.log("DEBUG :: No funds checked - adding some");
				self.checkedFunds = [45, 67, 34, 10];
				self.updateCheckedFunds();
			}
			self.pdfStartProcess();
		});
		$('#btn-pdfoutput').on('click', function () {
			console.log("DEBUG :: Testing PDF Output Method");
			var token = "8a44994d81654e0c01826f5548570002";
			self.pdfGetUrl(token);
		});
		$('#btn-addfunds').on('click', function () {
			self.checkedFunds = [45, 67, 34, 10];
			console.log("DEBUG :: Selected funds:", self.checkedFunds);
			self.updateCheckedFunds();
		});
		$('#btn-emulatePdf').on('click', function () {
			self.emulatePDF();
		});
		$('#btn-checkForNullSeries').on('click', function () {
			self.checkForNullSeries();
		});
		
		self.createDebugSlider();
	}
	self.emulatePDF = function () {
		var pdfUrl = '/static/module/tdv/pdf/TargetDateVisualizer.pdf';
		el.downloadButton[0].href = pdfUrl;
		el.downloadButton[0].download = "TargetDateVisualizer-" + new Date().getTime() + ".pdf";
		el.downloadButton[0].click();
		window.open(pdfUrl, '_blank');
	}
	self.createDebugSlider = function() {
		const labels = tl.getLabelsArray().map(label => new Object({
			'time': label.time,
			'name': label.name
		}));
		// Create slider
		const segments = labels.length - 1;
		const slider = document.createElement('input');
		slider.type = 'range';
		slider.min = 0;
		slider.max = segments;
		slider.step = 1;
		slider.classList.add('form-control-range');
		slider.addEventListener('input', () => {
			const labelIndex = parseInt(slider.value);
			const labelTime = labels[labelIndex].time;
			tl.progress(labelTime / tl.duration());
			tl.play();
		});
		document.querySelector('#debug-slider').appendChild(slider);
		// Create labels
		for (let i = 0; i < labels.length; i++) {
			const labelEl = document.createElement('span');
			labelEl.textContent = labels[i].name;
			labelEl.addEventListener('click', () => {
				tl.progress(labels[i].time / tl.duration());
				tl.play();
				console.log('TDV :: DEBUG :: Playing label:', labels[i].name);
				if (labels[i].name == 'report-success' || labels[i].name == 'report-error') {
					el.submissionModal.modal('show');
				}
			});
			Object.assign(labelEl.style, {
				left: `${i / segments * 100}%`,
				transform: 'translateX(-50%)'
			});
			labelEl.classList.add('debug-label', 'position-absolute');
			document.querySelector('#debug-slider-labels').appendChild(labelEl);
		}
		// Update slider on timeline update
		tl.eventCallback('onUpdate', () => {
			const progress = tl.progress();
			let closestLabelIndex;
			for (let i = 0; i < labels.length; i++) {
				if (progress * tl.duration() >= labels[i].time) {
					closestLabelIndex = i;
				} else {
					break;
				}
			}
			if (closestLabelIndex !== undefined) {
				slider.value = closestLabelIndex;
			}
		});
	}
	// <---- END DEBUG ---->

	self.checkForNullSeries = function () {
		var missingSeries = [];

		for (var i = 0; i < self.csvData.length; i++) {
			var seriesArr = self.getFundsBySeries(self.csvData[i][FUND_PARAMS.NAME]);
			var addSeries = true;
			if (seriesArr.length == 0 && self.csvData[i][FUND_PARAMS.NAME] != 'Industry Average Glidepath') {
				// missingSeries.push(self.csvData[i]);
			} else {
				// Loop through series
				for (var j = 0; j < seriesArr.length; j++) {
					var fund = seriesArr[j];
					// If in threshold, don't add
					if ( ( fund.year != undefined ) && ( fund.year > requestParams.oldestFundYear ) )
						addSeries = false;
				}
			}
			if (addSeries) {
				// console.log("DEBUG :: checkForNullSeries ::", self.csvData[i][FUND_PARAMS.NAME], seriesArr);
				missingSeries.push(self.csvData[i]);
				self.csvData[i].MISSING_SERIES = true;
			} else {
				self.csvData[i].MISSING_SERIES = false;
			}
		}
		console.log("TDV :: checkForNullSeries ::", { missingSeries: missingSeries, csvData: self.csvData });
	}

	self.assembleScriptCode = function (additionalSeriesNumber) {
		var template = 'Putnam_TDF_Template',
			managerScript = '';

		if ( (window.location.hostname != 'www.putnam.com') || (window.location.hostname != 'www-stg.putnam.com') ) {
			template = 'Putnam_TDF_Template_UAT';
		} 

		var script = 'USEUI(Ptm,' + template + '.sty);MANAGERSCLEAR(ClearALL);MANAGERSGROUPADD(Glidepaths);DELETEMACRO;';

		for (var i = 0; i < self.checkedFunds.length; i++) {
			managerScript += addManagerToRequest(self.checkedFunds[i]);
		}
		
		// Add additional series (current manager) if available
		if (additionalSeriesNumber) {
			managerScript += addManagerToRequest(additionalSeriesNumber);
		}

		// Image
		script += 'Assignmacro(image, ' + self.currentState.string + '.png);';
		// Away from retirement
		script += 'Assignmacro(away_from_retirement, ' + requestParams.highestYear + ');';
		// Near retirement
		script += 'Assignmacro(near_to_retirement, ' + requestParams.lowestYear + ');';

		// Form fields
		var nameField = el.analysisForm[0].elements['analysis-name'];
		var firmField = el.analysisForm[0].elements['analysis-firm'];
		var planSponsorField = el.analysisForm[0].elements['analysis-plan-sponsor'];
		var emailField = el.analysisForm[0].elements['analysis-email'];
		var phoneField = el.analysisForm[0].elements['analysis-phone'];

		// Client name
		if (nameField && nameField.value) {
			script += 'Assignmacro(clientname, ' + nameField.value + ');';
		}
		// Firm name
		if (firmField && firmField.value) {
			script += 'Assignmacro(firmname, ' + firmField.value + ');';
		}
		// Plan sponsor name
		if (planSponsorField && planSponsorField.value) {
			script += 'Assignmacro(plansponsorname, ' + planSponsorField.value + ');';
		}
		// Email
		if (emailField && emailField.value) {
			script += 'Assignmacro(clientemail, ' + emailField.value + ');';
		}
		// Phone
		if (phoneField && phoneField.value) {
			script += 'Assignmacro(clientphone, ' + phoneField.value + ');';
		}

		script += managerScript;
		script += 'Run;SrvGetReportPDF(Report, Report, , , mpiPDF, , 0);';

		console.log('TDV :: assembleScriptCode ::', { script: script});
		console.log('    :: assembleScriptCode :: Highest year:', requestParams.highestYear, ' Lowest year:', requestParams.lowestYear);

		return script;
	}

	self.pdfStartProcess = function (currentStrategy) {
		var script = self.assembleScriptCode(currentStrategy);
		requestParams.json["scriptcode"] = script;

		console.log('TDV :: pdfStartProcess :: requestParams :: ', [requestParams.json]);

		$.ajax({
			url: requestParams.tokenUrl,
			type: 'POST',
			data: JSON.stringify(requestParams.json),
			crossDomain: true,
			dataType: 'json',
			contentType: 'application/json; charset=utf-8'
		}).done(function (data) {
			console.log("    :: pdfStartProcess :: Done :: Data:", data);
		}).always(function (data) {
			console.log("    :: pdfStartProcess :: Always :: Status: ", data.status, " :: Data:", [data]);
			if (data.status == 200 && data.responseText) {
				requestParams.currentToken = data.responseText;
				self.pdfInitStatusQueue(data.responseText);
			} else {
				console.log("    :: pdfGetStatus :: ERROR");
				tl.play('report-error');
			}
		});

		tl.play('report-submission');
	}
	self.pdfInitStatusQueue = function (token) {
		var initialWaitPeriod 		= 30000; // 40 seconds
		var intervalWaitPeriod 		= 10000; // 10 seconds
		var timeoutWaitPeriod		= 240000 // 4 minutes
		requestParams.pdfReceived 	= false;

		console.log('TDV :: pdfInitStatusQueue :: token:', token);

		// Initial query wait
		setTimeout(function () {
			self.pdfGetStatus(token);

			// constant update query
			var counter = 0;
			pdfSubmissionInterval = setInterval(function () {
				console.log("    :: pdfInitStatusQueue :: Interval:", counter);
				if (!requestParams.pdfReceived) {
					self.pdfGetStatus(token);
				}
				if (counter >= 20) {
					console.log("    :: pdfInitStatusQueue :: Interval cleared");
					clearInterval(pdfSubmissionInterval);
				}
				counter++;
			}, intervalWaitPeriod)

		}, initialWaitPeriod);

		// Timeout error
		setTimeout(function () {
			if (!requestParams.pdfReceived) {
				tl.play('report-error');
			}	
		}, timeoutWaitPeriod);
	}
	self.pdfGetStatus = function (token) {
		console.log('TDV :: pdfGetStatus :: token:', token);

		$.ajax({
			url: requestParams.pdfStatusUrl,
			type: 'POST',
			data: token,
			dataType: 'json',
			contentType: 'application/json; charset=utf-8'
		}).done(function (data) {
			console.log("   :: pdfGetStatus :: Done :: Data:", data);
		}).always(function (data) {
			console.log("    :: pdfGetStatus :: Always :: Status:", data.status, " :: Data:", [data]);
			if (data.status == 200) {
				if (data.responseText == "PENDING") {
					console.log("    :: pdfGetStatus :: PENDING");
				} else if (data.responseText == "SUCCESS") {
					console.log("    :: pdfGetStatus :: SUCCESS");
					if (!requestParams.pdfReceived) {
						self.pdfGetUrl(token);
					}
					if (pdfSubmissionInterval) {
						console.log("    :: pdfGetStatus :: Interval cleared");
						clearInterval(pdfSubmissionInterval);
					}
				}
			} else {
				console.log("    :: pdfGetStatus :: ERROR");
				tl.play('report-error');
			}
		});
	}
	self.pdfGetUrl = function (token) {
		console.log('TDV :: pdfGetUrl :: token:', token);

		// Retrieval
		var xhr = new XMLHttpRequest();
		xhr.open("POST", requestParams.pdfGetUrl, true);
		xhr.setRequestHeader("Content-Type", "application/pdf");
		xhr.responseType = 'arraybuffer';

		// TODO: Fix error state. else is triggered twice before success for some reason.
		xhr.onreadystatechange = function (e) {
			if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
				passToOutput(this.response, [this]);
			} else /* if (!this.status === XMLHttpRequest.DONE) */ {
				console.log("    :: pdfGetUrl :: UPDATE", [this]);
				// tl.play('report-error');
			}
		}
		xhr.send(token);

		function passToOutput(data, debug) {
			console.log("    :: pdfGetUrl :: SUCCESS :: ", debug);

			requestParams.pdfReceived = true;
			tl.play('report-success');

			// Blob test
			var filename = "TargetDateVisualizer-" + new Date().getTime() + ".pdf";
			var blob = new Blob([data], { type: 'application/pdf' });

			// IE version
			if (typeof window.navigator.msSaveBlob !== 'undefined') {
				window.navigator.msSaveBlob(blob, filename);
				el.downloadButton.on('click', function(e){
					e.preventDefault();
					window.navigator.msSaveOrOpenBlob(blob, filename);
				});
			}
			else {
				var URL = window.URL || window.webkitURL;
				var downloadUrl = URL.createObjectURL(blob, { oneTimeOnly: true });
				el.downloadButton[0].href = downloadUrl;
				el.downloadButton[0].download = filename;
				el.downloadButton[0].click();
				window.open(downloadUrl, '_blank');
			}
		}
	}
	
	self.highlightFund = function (_id) {
		var checked = false;
		var id = '';
		// Get fund ID
		for (var i = 0; i < Object.keys(self.filteredFunds).length; i++) {
			if (self.filteredFunds[i][""] === _id)
				id = self.filteredFunds[i].ID;
		}

		for (var i = 0; i < self.highlightedFunds.length; i++) {
			if (self.highlightedFunds[i] == id) {
				checked = true;
			}
		}
		if (!checked) {
			self.highlightedFunds.push(id);
		}
		el.dataContainer.find('.id-' + id).addClass('highlight');
	}
	self.unHighlightFund = function (_id) {
		var id = '';
		// Get fund ID
		for (var i = 0; i < Object.keys(self.filteredFunds).length; i++) {
			if (self.filteredFunds[i][""] === _id)
				id = self.filteredFunds[i].ID;
		}
		
		for (var i = 0; i < self.highlightedFunds.length; i++) {
			if (self.highlightedFunds[i] == id) {
				self.highlightedFunds.splice(i, 1);
			}
		}
		el.dataContainer.find('.id-' + id).removeClass('highlight');
	}

	self.showFundDetails = function(fund) {
		var pathTypeCapitalized = fund.Glide_Path_Type.toLowerCase().charAt(0).toUpperCase() + fund.Glide_Path_Type.slice(1).toLowerCase(),
			isChecked 			= self.isFundChecked( fund.ID ),
			// date 				= new Date( fund[ FUND_PARAMS.INCEPTION ] ),
			// dateString 			= date.getMonth()+1 + '/' + date.getDate() + '/' +  date.getFullYear(),
			dateString  		= fund[FUND_PARAMS.INCEPTION],
			checkedString 		= isChecked ? 'checked' : '',
			equityStart;

		el.fundDetailModal.data('fund', fund.ID);

		// Update fund details

		for (var i = 0; i < FUND_PARAMS.GLIDE_PATH.length; i++) {
			if ( fund[ FUND_PARAMS.GLIDE_PATH[i] ] != 'NA') {
				equityStart = fund[ FUND_PARAMS.GLIDE_PATH[i] ];
				break;
			}
		}

		el.fundDetailModal.find('.modal-title').html( fund[ FUND_PARAMS.NAME ] );
		el.fundDetailModal.find('#inception-date').html( dateString );
		el.fundDetailModal.find('#glide-path-type').html( pathTypeCapitalized );
		el.fundDetailModal.find('#is-cit').html( ( Number(fund.is_CIT) ? "CIT" : "Mutual Fund" ) ) ;
		el.fundDetailModal.find('#avg-manager-tenure').html( fund[ FUND_PARAMS.MGR_TENURE ] ) ;
		el.fundDetailModal.find('#sum-assets').html( Number( fund[ FUND_PARAMS.SUM_ASSETS ] ).toLocaleString('en') ) ;
		el.fundDetailModal.find('#equity-start').html(  equityStart + '%' );
		el.fundDetailModal.find('#equity-retirement').html( fund[ FUND_PARAMS.GLIDE_PATH[10] ] + '%' );

		self.addGlidePath( el.fundDetailModal, [fund], { addFundSelect:true } );

		var checkbox =  '<div class="form-check fund-check pl-2">' +
							'<input type="checkbox" id="fund-' + fund.ID + '-modal" data-fund="' + fund.ID + '" class="form-check-input d-none "' + checkedString + '>' +
							'<label class="form-check-label btn btn-primary" for="fund-' + fund.ID + '-modal">Add to comparison</label>' +
						'</div>';
		el.fundDetailModal.find('.fund-checkbox').html( checkbox );

		self.updateCheckedFunds();
		el.fundDetailModal.modal();
	}

	self.showFundAnalysis = function() {
		var selectedFundArray = [];
		for (var i = 0; i < self.checkedFunds.length; i++) {
			selectedFundArray.push( self.getFilteredFundsByID( self.checkedFunds[i] ) );
		}
		// Pass glide path element
		// Show analysis inline
		self.addGlidePath(el.analysisChart, selectedFundArray, { showFundDetails: true });
		tl.play('analysis');

		// Show analysis in modal
		/* self.addGlidePath(el.analysisModal, selectedFundArray, { showFundDetails:true } );
		el.analysisModal.modal();

		$(el.analysisModal).on('hidden.bs.modal', function (e) {
			self.formReset(el.analysisModal[0], true);
		}); */
	}

	self.submitAnalysis = function (e, formSubmit) {
		// var form = e.target,
		var form = e,
			formWrapper = $(form).parents('.analysis-wrapper')[0],
			formReplace = formWrapper.querySelector('.form-replace'),
			formSuccess = formWrapper.querySelector('.form-success'),
			formError = formWrapper.querySelector('.form-error'),
			formElements = {
				inputs: {
					name: form.elements['analysis-name'],
					firm: form.elements['analysis-firm'],
					email: form.elements['analysis-email'],
					phone: form.elements['analysis-phone']
				},
				planSponsorName: form.elements['analysis-plan-sponsor'],
				currentStrategy: el.analysisManagerSelect[0].querySelector('select'),
				submitButton: formSubmit ? formSubmit : el.submitButton
			},
			submitButtonHtml = formElements.submitButton.innerHTML;
		var currentStrategyStr = '';
		if (formElements.currentStrategy && formElements.currentStrategy.selectedIndex != 0) {
			currentStrategyStr = formElements.currentStrategy.value != 'other' ? formElements.currentStrategy[formElements.currentStrategy.selectedIndex].dataset.fundName.replace('®', '') : 'other';
		}
		var	submitData = {
				'advisor_name': getVal(formElements.inputs.name.value),
				'firm': getVal(formElements.inputs.firm.value),
				'email': getVal(formElements.inputs.email.value),
				'plan_sponsor': getVal(formElements.planSponsorName.value),
				'phone': getVal(formElements.inputs.phone.value.replace(/\D/g,'')),
				'funds_requested': getVal(form.elements['analysis-funds'].value),
				'current_manager': getVal(currentStrategyStr)
			};

		// Disable submit
		formElements.submitButton.style.width = null;
		formElements.submitButton.style.width = ( formElements.submitButton.offsetWidth + 1 ) + 'px';
		formElements.submitButton.disabled = true;
		formElements.submitButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';

		// Validate input that's not empty
		for (var key in formElements.inputs) {
			if (formElements.inputs.hasOwnProperty(key)) {
				var element = formElements.inputs[key];
				if (element.value.trim() !== '') {
					if ( !element.checkValidity() ) {
						element.classList.add('is-invalid');
						console.log('TDV :: submitAnalysis :: Invalid input:', element, element.value);
					} else {
						element.classList.remove('is-invalid');
						console.log('TDV :: submitAnalysis :: Valid input:', element, element.value);
					}
				}
			}
		}

		// If name is null, pass a default value
		if (submitData.advisor_name === null) {
			submitData.advisor_name = 'Advisor';
		}
		
		// If currentStrategy is empty, return error, reset submit button, and exit
		if (formElements.currentStrategy) {
			if (formElements.currentStrategy.selectedIndex == 0) {
				formElements.currentStrategy.classList.add('is-invalid');
				formElements.currentStrategy.focus();
				formElements.submitButton.disabled = false;
				formElements.submitButton.innerHTML = submitButtonHtml;
				console.log('TDV :: submitAnalysis :: Invalid input:', formElements.currentStrategy, formElements.currentStrategy.value);
				return false;
			} else {
				formElements.currentStrategy.classList.remove('is-invalid');
			}
		}

		console.log('TDV :: submitAnalysis ::', { submit_data: submitData });

		// Email submission
		$.ajax({
			url: '/dcio/targetdatevisualizer/sendemail',
			type: 'POST',
			data: JSON.stringify(submitData),
			dataType: 'json',
			contentType: 'application/json; charset=utf-8',
			success: function (data) {
				console.log("TDV :: submitAnalysis :: Success:", data);
				// hideElement(formReplace, 0);
				// showElement(formSuccess);

				formElements.submitButton.disabled = false;
				formElements.submitButton.innerHTML = submitButtonHtml;

				if (formElements.currentStrategy && formElements.currentStrategy.value != 'other' )
					self.pdfStartProcess(formElements.currentStrategy.value)
				else
					self.pdfStartProcess();

				self.formApplyDefaults(form);
			},
			failure: function (data) {
				console.log("Fail", data);
			},
			error: function (data) {
				console.log("TDV :: submitAnalysis :: Error:", data.responseJSON.resultMessage, {formData:data});
				if (data.responseJSON) {
					if (data.responseJSON.resultMessage == 'Please provide a valid email address') {
							formElements.inputs.email.classList.add('is-invalid');
					} else if (data.responseJSON.resultMessage == 'Invalid phone number/format.') {
							formElements.inputs.phone.classList.add('is-invalid');
					} else {
							tl.play('report-error');
					}
				} else {
					// hideElement(form, 0);
					// showElement(formError, 0.5);
					self.formApplyDefaults(form);
				}

				formElements.submitButton.disabled = false;
				formElements.submitButton.innerHTML = submitButtonHtml;
			}
		});
	}

	// Reset form inside of specified form container
	self.formReset = function(formContainer, preserveInputValues) {
		var form 			= formContainer.querySelector('form'),
			formReplace 	= formContainer.querySelector('.form-replace'),
			formSuccess 	= formContainer.querySelector('.form-success'),
			formError 		= formContainer.querySelector('.form-error'),
			preserveInputValues = ( preserveInputValues != undefined ) ? preserveInputValues : true;

		if (!preserveInputValues) {
			self.formApplyDefaults(form);
		}

		// showElement(form, 0);
		showElement(formReplace, 0);
		hideElement(formSuccess, 0);
		hideElement(formError, 0);
	}

	// Apply all form default values set in dataset.defaultValues
	self.formApplyDefaults = function(form) {
		var formInputs = form.querySelectorAll('input');

		for (var i = 0; i < formInputs.length; i++) {
			var formType = formInputs[i].getAttribute('type');
			if (formInputs[i].dataset.defaultValue) {
				formInputs[i].value = formInputs[i].dataset.defaultValue;
			} else if ( formType != 'hidden' ) {
				if (formType == 'checkbox') {
					formInputs[i].checked = false;
				} else {
					formInputs[i].value = '';
				}
			}
		}
	}

	// Store analysis form data on input
	self.formStoreAnalysisDefaults = function() {
		var formName = el.analysisForm[0].querySelector('#analysis-name');
		var formFirm = el.analysisForm[0].querySelector('#analysis-firm');
		var formPlanSponsor = el.analysisForm[0].querySelector('#analysis-plan-sponsor');
		var formEmail = el.analysisForm[0].querySelector('#analysis-email');
		var formPhone = el.analysisForm[0].querySelector('#analysis-phone');

		formName.dataset.defaultValue = formName.value;
		formFirm.dataset.defaultValue = formFirm.value;
		formPlanSponsor.dataset.defaultValue = formPlanSponsor.value;
		formEmail.dataset.defaultValue = formEmail.value;
		formPhone.dataset.defaultValue = formPhone.value;
	}

	self.addGlidePath = function(wrapper, funds, options) {
		// options.addFundSelect
		// options.showFundDetails

		var glide = {
				chart:  wrapper.find('.glide-path'),
				key: 	wrapper.find('.glide-key')
			},
			series 			= [],
			keyHTML 		= '',
			symbolHTML;

		// Unbind any existing event listeners
		wrapper.unbind();
		glide.key.unbind();

		// Set up key table
		if (options.showFundDetails) {
			keyHTML += 	'<thead>' +
						'<tr>' +
							'<th colspan="3" class="border-0"></th>' +
							'<th colspan="2" class="border-0 pb-0 pr-3 text-center">Equity at</th>' +
							'<th class="border-0"></th>' +
						'</tr>' +
						'<tr>' +
							'<th class="border-top-0 pt-0">Fund</th>' +
							'<th class="border-top-0 pt-0 text-center">CIT</th>' +
							'<th class="border-top-0 pt-0 text-center">Type</th>' +
							'<th class="border-top-0 pt-0 text-center">Start</th>' +
							'<th class="border-top-0 pt-0 text-center pr-0">Retirement</th>' +
							'<th class="border-top-0 pt-0"></th>' +
						'</tr></thead>';
		}
		keyHTML += '<tbody>';

		// Set up each fund series. Adds individual colors, markers, symbols, and data
		for (var i = 0; i < funds.length; i++) {

			var equityStart;
			for (var j = 0; j < FUND_PARAMS.GLIDE_PATH.length; j++) {
				if ( funds[i][ FUND_PARAMS.GLIDE_PATH[j] ] != 'NA') {
					equityStart = funds[i][ FUND_PARAMS.GLIDE_PATH[j] ];
					break;
				}
			}

			series.push( self.getGlidePathSeriesData(funds[i], i) );

			symbolHTML = self.getGlidePathKeySymbol( FUND_PARAMS.SERIES_MARKERS[i], FUND_PARAMS.SERIES_COLORS[i]);

			keyHTML += '<tr class="active" data-series-id="' + i + '" data-fund-id="' + funds[i][FUND_PARAMS.ID] + '">' +
							'<td><div>' + symbolHTML + funds[i][FUND_PARAMS.NAME] + '</div></td>';

			// Show fund specific details in key if option is true
			if (options.showFundDetails) {
				var cit = Number( funds[i][FUND_PARAMS.CIT] ) ? "Yes" : "No";
				keyHTML += 	'<td class="text-center"><div>' + cit + '</div></td>' +
							'<td class="text-center"><div>' + funds[i][FUND_PARAMS.PATH_TYPE].replace('Retirement', '') + '</div></td>' +
							'<td class="text-center"><div>' + equityStart + '%</div></td>' +
							'<td class="text-center"><div class="pr-0">' + funds[i][FUND_PARAMS.GLIDE_PATH[10]] + '%</div></td>' +
							'<td><div class="p-0"><button class="delete-series close">x</button></div></td>';
			}
			keyHTML += '</tr>';
		}

		// Set up glidepath highchart
		var glidePath = Highcharts.chart(glide.chart[0], {
			chart: {
				height: ( 9 / 16 * 100 ) + '%',
				marginLeft: 40
			},
			plotOptions: {
				line: {
					color: FUND_PARAMS.CATEGORIES[0]
				}
			},
			title: {
				text: ''
			},
			yAxis: {
				title: {
					enabled:false
				},
				min:0,
				max:100,
				labels: {
					formatter: function() {
						return this.value + '<span style="font-size:9px">%</span>';
					}
				}
			},
			xAxis: {
				categories: FUND_PARAMS.CATEGORIES,
				tickmarkPlacement:'on',
				gridLineWidth: 1,
				plotLines: [{
					value:10,
					width:2,
					zIndex:3,
					color:'#888888'
				}],
				labels: {
					formatter: function() {
						return (this.value.y === 0) ? '<span style="font-weight:bold;">' + this.value.y + '</span>' : this.value;
					}
				}
			},
			series: series,
			tooltip: {
				useHTML: true,
				formatter: function() {
					var tense = this.point.index < 10 ? 'until' : 'into',
						h1 = '<b>' + this.x + '</b> years ' + tense + ' retirement<br>',
						header = this.point.index == 10 ? 'At retirement<br>' : h1;
					return 	'<b style="color:' + this.series.color + ';">' + this.series.name + '</b><br>' +
							'<span style="margin-bottom:2px;">' + header + '</span>' +
							'<b>' + this.y + '%</b> equity allocation';
				}
			},
			credits: {
				enabled: false
			}
		});

		// Add fund select dropdown for comparision.
		if (options.addFundSelect) {
			var selectID 	= funds.length,
				selectColor = '#aaaaaa';

			glidePath.addSeries( self.getGlidePathSeriesData( self.industryAverage, selectID, { color:selectColor, zIndex:-1 } ) );

			glide.key.on('change', '.glide-compare', function(e) {
				var selectedFund 	= e.target.value == 'average' ? self.industryAverage : self.getFilteredFundsByID( e.target.value ),
					selectSeries	= self.getGlidePathSeriesData( selectedFund, selectID, { color:selectColor, zIndex:-1 } );

				if ( glidePath.get(selectID) ) {
					glidePath.get(selectID).remove();
				}
				glidePath.addSeries(selectSeries);
			});
			var selectDropdown = self.getFundSelectDropdown({ 
				excludeArr: [funds[0].ID],
				includeIndustryAverage: true
			})
			keyHTML += '<tr class="active" data-series-id="' + funds.length + '">' +
							'<td class="select-cell"><div>' + self.getGlidePathKeySymbol( FUND_PARAMS.SERIES_MARKERS[funds.length], selectColor ) + selectDropdown + '</div></td>' + 
						'</tr>';
		}
		keyHTML += '</tbody>';

		glide.key[0].innerHTML = keyHTML;


		// Glide path event handlers

		// Handle table row hovering to highlight a series line or point
		wrapper.on('mouseover mouseout', 'tr', function(e) {
			var seriesID 	= Number( e.currentTarget.dataset.seriesId ),
				pointID		= e.currentTarget.dataset.pointId,
				rowIndex 	= this.sectionRowIndex,
				select 		= $(e.currentTarget).find('select')[0],
				selectIndex = select ? select.selectedIndex : undefined;

			// If series ID and a point, select point
			if (seriesID >= 0 && pointID != undefined) {

				// If pointID is set to get first available point, set first non-null point as id
				if (pointID == 'first') {
					for (var j = 0; j < glidePath.series[seriesID].data.length; j++) {
						if ( !glidePath.series[seriesID].data[j].isNull ) {
							pointID = j;
							break;
						}
					}
				} else {
					pointID = Number( pointID );
				}

				// If mouseover, set hover to series id and point id.
				if (e.type == 'mouseover') {
					glidePath.series[seriesID].data[pointID].setState('hover');
					glidePath.tooltip.refresh(glidePath.series[seriesID].points[pointID]);

				// If mouseout, hide series id and point id
				} else {
					glidePath.series[seriesID].data[pointID].setState();
					glidePath.tooltip.hide();
				}

			// If series ID and no point ID, highlight series
			} else if (seriesID >= 0) {

				// If mouseover, add hover class to series id
				if (e.type == 'mouseover') {
					glide.chart.find('.highcharts-series-group').children().each(function() {
						var $this = $(this);
						if ( $this.hasClass('highcharts-series-' + rowIndex) ) {
							$this.addClass('highcharts-series-hover');
						} else {
							$this.addClass('highcharts-series-inactive');
						}
					});

				// If mouseout, remove all hover classes
				} else {
					glide.chart.find('.highcharts-series-group').children().removeClass('highcharts-series-hover highcharts-series-inactive');
				}
			}
		});
		
		glide.key.on('click', '.delete-series', function(e) {
			var $this 		= $(this),
				fundRow 	=  $this.parents('tr'),
				seriesID 	= Number( fundRow[0].dataset.seriesId ),
				fundID 		= fundRow[0].dataset.fundId;

			// Delete series id from glide chart
			if ( glidePath.get(seriesID) ) {
				glidePath.get(seriesID).remove();
			}
			// deselect fund ID
			self.deselectFund(fundID);
			// Remove row from table
			fundRow.removeClass('active');
			setTimeout(function(){ fundRow.remove() }, 300);

			if (self.checkedFunds.length == 0) {
				// wrapper.modal('hide');
				tl.play('selection');
			}
			querySubmit();
		});
	}

	self.handleAnswerChange = function(e) {
		var q1 = 0, q2 = 0, q3 = 0;

		el.answers.each(function(i, el) {
			// var val = Number( el.value );
			var val = ( el.value == "" ) ? undefined : Number(el.value);
			
			if (el.id == "earlyAccumulation") {
				q1 = val;
			} else if (el.id == "lateAccumulation") {
				q2 = val;
			} else if (el.id == "overall") {
				q3 = Number(el.value);
			}
		});

		// If q1 and q2 are either 1 or 5, set self.enableQ3 to false
		self.enableQ3 = ( (q1 == 1 || q1 == 5) && (q2 == 1 || q2 == 5) ) ? false : true;

		// if q1 and q2 are both set, and the current label is either questions or questions-2, play questions-2
		// TODO: Fix current label so it's properly set to "questions" during first set of questions. Currently autoplaying to question-2
		// if (self.enableQ3 && q1 != undefined && q2 != undefined && tl.currentLabel() == "questions") { // This should be proper working conditional
		if (self.enableQ3 && q1 != undefined && q2 != undefined && (tl.currentLabel() == "questions" || tl.currentLabel() == "questions-2") && !$('#question-3').is(":visible")) {
			tl.play("questions-2");
		}

		// q1 += q3;
		// q2 += q3;
		q1 = q1 ? q1 + q3 : q1;
		q2 = q2 ? q2 + q3 : q2;

		// Apply third question value modifier to first two questions
		// Final score
			// Early accumulation
				// greater than or equal to 3 - top half
				// less than 3 - bottom half
			// Late accumulation
				// greater than 3 - right half
				// less than or equal to 3 - left half

		// greater than 3 = top
		// less than 3 = bottom

		// Balanced shouldn't sort. Should stay centered.
		// Third question shouldn't change maximum amounts with -1/1 selection.

		// Top
		if (q1 > 3) {
			// Right
			if (q2 > 3) {
				self.updateState(STATE.TOP_RIGHT);
				// Left
			} else if (q2 < 3) {
				self.updateState(STATE.TOP_LEFT);
			} else {
				// Top
				self.updateState(STATE.TOP);
			}
			// Bottom
		} else if (q1 < 3) {
			// Right
			if (q2 > 3) {
				self.updateState(STATE.BOTTOM_RIGHT);
				// Left
			} else if (q2 < 3) {
				self.updateState(STATE.BOTTOM_LEFT);
			} else {
				// Bottom
				self.updateState(STATE.BOTTOM);
			}
		} else {
			// Right
			if (q2 > 3) {
				self.updateState(STATE.RIGHT);
				// Left
			} else if (q2 < 3) {
				self.updateState(STATE.LEFT);
				// Default
			} else {
				self.updateState(STATE.DEFAULT);
			}
		}

		// If all questions have been answered, enabled next button
		queryNext();

		console.log("TDV :: handleAnswerChange :: Q1:", q1, " Q2:", q2, " Q3:", q3);
	}

	self.handleHover = function(e) {
		var x = Math.round(e.pageX - self.targetDate.offset().left),
			y = Math.round(e.pageY - self.targetDate.offset().top),

			// TODO: remove outside of hover
			addPointThreshold = 135,
			scaleThreshold 	= 2, // Threshold for max scale amount
			scaleReduction 	= 1, // Fisheye overall scale reduction (0-1)
			selectDistance 	= 6, // Distance in pixels from point in order to initiate hover

			lowest 			= Number.POSITIVE_INFINITY,
			closestPoint 	= {},
			hoverPoint,
			tmp;

		// Show/hide magnify
		el.magnify.container[0].style.display = (e.type == 'mouseleave') ?  "none" : "block";

		// Animate magify ui to mouse position
		var dur = (e.type == 'mouseenter') ? 0 : 0.1;
		TweenMax.to(el.magnify.container, dur, {
			left:x - magnifyRadius,
			top:y - magnifyRadius
		});

		// Set focus point for fisheye lens
		magnifyWindow.focus([magnifyRadius, magnifyRadius]);

		// Update axis in magnify ui
		for (var l = 0; l < el.magnify.lines.length; l++) {
			self.updateMagnifyAxis(el.magnify.lines[l], x, y);
		}

		// Loop through all funds and apply effects to funds within
		for (var f in self.filteredFunds) {
			var pctY 	= self.filteredFunds[f].yPos/100,
				pctX 	= self.filteredFunds[f].xPos/100,
				posY 	= Math.round(params.containerHeight - (params.containerHeight*pctY)),
				posX 	= Math.round(params.containerWidth*pctX),
				a 		= posX - (x - params.xOffset),
				b 		= posY - (y - params.yOffset),
				c 		= Math.sqrt(a*a + b*b),
				pointInMagnifier = false;

			// Loop through stored magnified point array. Check to see if fund matches point in array.
			// If it's out of bounds and in array, remove it, otherwise save pointInMagnifier as true
			for (var i = 0; i < self.magnifiedPoints.length; i++) {
				if (self.magnifiedPoints[i].f.ID == self.filteredFunds[f].ID) {
					// Remove point if matched point is out of bounds
					if (c >= addPointThreshold) {
						self.magnifiedPoints[i].point.remove();
						self.magnifiedPoints.splice(i, 1);
					} else {
						pointInMagnifier = true;
						self.magnifiedPoints[i].a = a;
						self.magnifiedPoints[i].b = b;
						self.magnifiedPoints[i].c = c;
						self.magnifiedPoints[i].x = a + addPointThreshold;
						self.magnifiedPoints[i].y = b + addPointThreshold;
					}
				}
			}

			// If point is in magnifier threshold and not in magnified point array, add point
			if (c < addPointThreshold) {
				if (!pointInMagnifier) {
					var pointY 		= b + addPointThreshold,
						pointX 		= a + addPointThreshold,
						newPoint 	= $('<div class="point text-right" style="top:'+pointY+'px;left:'+pointX+'px;opacity:0;"><span style="white-space:nowrap;">' + self.filteredFunds[f].Strategy_Name + '</span></div>');
						
					self.magnifiedPoints.push({
						point: 	newPoint,
						f: 		self.filteredFunds[f],
						c: 		c,
						x: 		a + addPointThreshold,
						y: 		b + addPointThreshold
					});
					el.magnify.container.append(newPoint);
				}
			}
		}

		// Animate DOM points into position
		for (var j = 0; j < self.magnifiedPoints.length; j++) {
			var pctFromPoint 	= self.magnifiedPoints[j].c / addPointThreshold,
				m 				= magnifyWindow( { x:self.magnifiedPoints[j].x, y:self.magnifiedPoints[j].y } ), // Returns obj with {x, y, z} coordinates
				targetScale 	= m.z * scaleReduction;

			TweenMax.to(self.magnifiedPoints[j].point[0], 0.1, {
				left: 	m.x - 30,
				top:	m.y - 30,
				scale: 	targetScale > scaleThreshold ? scaleThreshold : targetScale,
				opacity:0.95 - pctFromPoint
			});

			if ( self.magnifiedPoints[j].point.hasClass('focus') )
				self.magnifiedPoints[j].point.removeClass('focus');

			// If point is checked in fund list, add selected class
			for (var n = 0; n < self.checkedFunds.length; n++) {
				if (self.checkedFunds[n] == self.magnifiedPoints[j].f.ID)
					self.magnifiedPoints[j].point.addClass('selected');
			}
			// If point is highlighted in fund list, add highlight class
			for (var o = 0; o < self.highlightedFunds.length; o++) {
				if (self.highlightedFunds[o] == self.magnifiedPoints[j].f.ID)
					self.magnifiedPoints[j].point.addClass('highlight');
			}

			// If hovering over point text, default to hover point
			// X: a < 0 && Math.abs(a) < text.width
			// Y: Math.abs(b) < 6
			if ( (self.magnifiedPoints[j].a < 0 && Math.abs(self.magnifiedPoints[j].a) < self.magnifiedPoints[j].point[0].children[0].clientWidth) && Math.abs(self.magnifiedPoints[j].b-3) < 5 ) {
				hoverPoint = self.magnifiedPoints[j];
			}

			// Set point within defined range as closest point
			tmp = self.magnifiedPoints[j].c;
			if (tmp < lowest) {
				lowest = tmp;
				closestPoint = self.magnifiedPoints[j];
			}
		}

		// Hover handling for magnified point
		if (closestPoint.c <= selectDistance && e.type != 'mouseleave') {
			hoverPoint = closestPoint;
		}

		if (hoverPoint != undefined && e.type != 'mouseleave') {
			document.body.style.cursor = "pointer";
			self.hoveringFund = hoverPoint.f;
			hoverPoint.point.addClass('focus');
		} else {
			document.body.style.cursor = "default";
			self.hoveringFund = undefined;
		}
		// Remove all points when exiting magnify ui
		if (e.type == 'mouseleave') {
			for (var k = 0; k < self.magnifiedPoints.length; k++) {
				self.magnifiedPoints[k].point.remove();
			}
			self.magnifiedPoints = [];
		}
	}

	self.handleFundCheck = function(e, fundID) {
		if( e.target.type == "checkbox" ) {
			if ( self.isFundChecked(fundID) ) {
				self.deselectFund(fundID);
			} else if ( self.checkedFunds.length >= self.checkedFundLimit ) {
				e.preventDefault();
				self.handleTooltip(e.currentTarget, e);
			} else {
				self.selectFund(fundID);
			}
			queryNext();
		}
	}

	self.handleTooltip = function(bindingElement, event) {
		var t = event.pageY - 15,
			l = event.pageX,
			a = 0.9,
			d = event.type == 'mouseenter' ? 0 : 0.3;

		if (el.tooltip == undefined) {
			el.tooltip = document.createElement('div');
			el.tooltip.setAttribute('class', 'tooltip');
			el.tooltip.style.cssText = 'opacity:' + a + ';top:' + (t-50) + 'px;left:' + (l-105) + 'px;';
			el.tooltip.textContent = 'You may only select up to ' + self.checkedFundLimit + ' strategies.';
			document.body.appendChild( el.tooltip );
		} else if ( event.target.className.indexOf('show-fund-modal') === -1 ) {
			t -= el.tooltip.offsetHeight;
			l -= el.tooltip.offsetWidth / 2;
			if (event.type == 'mouseout') {
				a = 0;
				t -= 30;
			} else if (event.type == 'mousedown') {
				t += 7;
			}
			TweenMax.to( el.tooltip, d, { top:t, left:l, autoAlpha:a, ease:Power4.easeOut } );
		}
	}

	// Animate axis and chart border in magnify ui
	self.updateMagnifyAxis = function(obj, x, y) {
		var axisPoints 				= 20,
			containerSize 			= (obj.axis == "x") ? params.containerHeight : params.containerWidth,
			containerSizeParallel 	= (obj.axis == "x") ? params.containerWidth : params.containerHeight,
			offset 					= (obj.axis == "x") ? params.yOffset : params.xOffset,
			offsetParallel			= (obj.axis == "x") ? params.xOffset : params.yOffset,
			mousePos 				= (obj.axis == "x") ? y : x,
			axisPos 				= Math.round(containerSize * obj.position),
			axisA					= axisPos - (mousePos - offset),
			axisOffset 				= axisA + magnifyRadius,
			axisStartPos 			= 1,
			axisEndPos 				= magnifyDiameter,
			magnifyStartPos			= (obj.axis == "x") ? x - magnifyRadius : y - magnifyRadius,
			magnifyEndPos 			= (obj.axis == "x") ? x + magnifyRadius : y + magnifyRadius;

		// Sets axis start position in magnify ui
		if (magnifyStartPos < 0) {
			axisStartPos = Math.abs(magnifyStartPos) + offsetParallel;
			if (obj.axis == 'y' && obj.position == 0.5) {
				// console.log("Start", axisStartPos, offsetParallel);
			}
		}
		// Sets axis end position in magnify ui
		if (magnifyEndPos > containerSizeParallel) {
			axisEndPos = (magnifyDiameter - (magnifyEndPos - containerSizeParallel)) + offsetParallel;
		}
		// 
		if (axisOffset > 0 && axisOffset < magnifyDiameter) {
			var d = "";
			for (var i = 0; i < axisPoints; i++) {
				var point 			= i * ( magnifyDiameter / axisPoints);
				if (point < axisStartPos) 	point = axisStartPos;
				if (point > axisEndPos) 	point = axisEndPos;
				var magnifyPoint 	= (obj.axis == "x") ? { x:point, y:axisOffset } : { x:axisOffset, y:point };
				var target 			= magnifyWindow( magnifyPoint );
				d += i == 0 ? "M" : " L"; 
				d += target.x + "," + target.y;
			}
			if (obj.el) {
				TweenMax.to(obj.el, 0.1, {
					attr:{
						d: d
					}
				});
			} else {
				var path = $( document.createElementNS('http://www.w3.org/2000/svg', 'path') );
				path.attr({
					fill:'none',
					stroke:'#cccccc',
					d:d
				});
				obj.el = path;
				el.magnify.svg.append(obj.el);
			}
		} else if(obj.el){
			obj.el.remove();
			obj.el = undefined;
		}
	}

	self.filterFunds = function(updateFundList) {
		var amt 			= 0,
			filterArr 		= [],
			newCheckedArr 	= [];
		self.filteredFunds 	= {};

		updateFundList = updateFundList == undefined ? true : updateFundList;

		for(var f in self.filter.funds) {
			if (self.filter.funds[f]) {
				filterArr.push(f);
			}
		}

		for (var i = 0; i < self.csvData.length; i++) {
			var y 		= self.csvData[i][FUND_PARAMS.FARTHEST_PERCENTILE]*100,
				x 		= self.csvData[i][FUND_PARAMS.CLOSEST_PERCENTILE]*100,
				xShow 	= (x >= self.filter.x.min && x <= self.filter.x.max),
				yShow 	= (y >= self.filter.y.min && y <= self.filter.y.max),
				filterShow = true;
			if(x && y){
				// Check if fund applies to filtered values
				if (filterArr.length) {
					for (var j = 0; j < filterArr.length; j++) {
						if ( ( filterArr[j] == "to"			&& ( self.csvData[i][FUND_PARAMS.PATH_TYPE] != "To Retirement" ) ) ||
							 ( filterArr[j] == "thru"		&& ( self.csvData[i][FUND_PARAMS.PATH_TYPE] != "Through Retirement" ) ) ||
							 ( filterArr[j] == "mutualFund"	&& ( self.csvData[i][FUND_PARAMS.CIT] != "0" ) ) ||
							 ( filterArr[j] == "cit"		&& ( self.csvData[i][FUND_PARAMS.CIT] != "1" ) )
							) {
						} else {
							filterShow = false;
						}
					}
				}
				if (xShow && yShow && filterShow && !self.csvData[i].MISSING_SERIES) {
					self.filteredFunds[amt] = self.csvData[i];
					self.filteredFunds[amt][FUND_PARAMS.ID] = i;
					self.filteredFunds[amt][FUND_PARAMS.X_POSITION] = x;
					self.filteredFunds[amt][FUND_PARAMS.Y_POSITION] = y;
					amt++;
				}
			}

			if (self.csvData[i][FUND_PARAMS.NAME] == 'Industry Average Glidepath') {
				self.industryAverage = self.csvData[i];
			}
		}

		// Remove checked funds from updated filtered fund list
		for (var c = 0; c < self.checkedFunds.length; c++) {
			var fundID = self.checkedFunds[c];
			for (var u in self.filteredFunds) {
				if(self.filteredFunds[u].ID == fundID)
					newCheckedArr.push(fundID);
			}
		}
		self.checkedFunds = newCheckedArr;
		self.updateCheckedFunds();

		console.log("TDV :: filterFunds ::", {"Filter Array":filterArr, "Filtered Fund Object":self.filteredFunds, "Industry Average":self.industryAverage });

		// Disable and hide fund list if there are no funds
			// Fund list: Show/hide strategies - moved list to sidebar, and removed button
		if (el.fundListButton.length > 0) {
			if ( Object.keys(self.filteredFunds).length ) {
				el.fundListButton[0].disabled = false;
			} else {
				el.fundList.collapse('hide');
				el.fundListButton[0].disabled = true;
			}
		}

		el.highlightPutnamFundsButtonCheck[0].checked = (!self.filteredFundsHasPutnam) ? false : el.highlightPutnamFundsButtonCheck[0].checked;

		self.updateFundPoints();
		
		if (updateFundList)
			self.updateFundList();
	}

	self.updateFundPoints = function() {
		var html 	= '',
			i 		= 0;
		for (var fund in self.filteredFunds) {
			var id 		= self.filteredFunds[i][FUND_PARAMS.ID],
				textPos = (self.filteredFunds[i][FUND_PARAMS.X_POSITION] > 50) ? "text-left" : "text-right",
				selected = '';
			for (var c = 0; c < self.checkedFunds.length; c++) {
				if (self.checkedFunds[c] == id)
					selected = ' selected';
			}
			html += "<div class='point id-" + id + " " + textPos + selected + "' " +
						"style='" + 
							"left:calc(" + self.filteredFunds[i][FUND_PARAMS.X_POSITION] + "% - 5px);" +
							"bottom:calc(" + self.filteredFunds[i][FUND_PARAMS.Y_POSITION] + "% - 5px);'" +
						"data-x='" + self.filteredFunds[i][FUND_PARAMS.X_POSITION] + "'" +
						"data-y='" + self.filteredFunds[i][FUND_PARAMS.Y_POSITION] + "'" +
						"data-index='" + i + "'" +
					">" +
						"<span>" + self.filteredFunds[i][FUND_PARAMS.NAME] + "</span>" +
					"</div>";
			i++;
		}
		el.dataContainer[0].innerHTML = html;
	}

	self.updateFundList = function() {
		var html 		= '',
			sortedFunds = self.getSortedFundList();
		
		for (var i = 0; i < sortedFunds.length; i++) {
			html += self.getFundCheckbox(sortedFunds[i][FUND_PARAMS.ID]);
		}

		el.attrDataFunds.attr('data-funds', i);
		el.fundListForm[0].innerHTML = html;
	}

	// Chart view changing functions
	self.updateState = function(state) {
		self.currentState = state;
		self.updateView(state.options);
		self.filter.y.min = 0;
		self.filter.x.min = 0;
		self.filter.y.max = 100;
		self.filter.x.max = 100;
		self.filterFunds(false);
		setTimeout(function() {
			self.filter.y.min = state.filter.y.min;
			self.filter.x.min = state.filter.x.min;
			self.filter.y.max = state.filter.y.max;
			self.filter.x.max = state.filter.x.max;
			self.filterFunds();
		}, 400);


		// Show/hide label arrows depending on state
		var yConservativeOpacity 	= state.filter.y.min >= 50 ? 0 : 1,
			yAggressiveOpacity 		= state.filter.y.max <= 50 ? 0 : 1,
			xConservativeOpacity 	= state.filter.x.min >= 50 ? 0 : 1,
			xAggressiveOpacity 		= state.filter.x.max <= 50 ? 0 : 1;

		el.labels.arrows.y.conservative.css({ opacity: yConservativeOpacity });
		el.labels.arrows.y.aggressive.css({ opacity: yAggressiveOpacity });
		el.labels.arrows.x.conservative.css({ opacity: xConservativeOpacity });
		el.labels.arrows.x.aggressive.css({ opacity: xAggressiveOpacity });

		// console.log("TDV :: updateState ::", self.currentState);
	}

	self.updateView = function(options) {
		var duration = 0.7,
			defaultOptions = {
			height: '100%',
			width: '100%',
			top: 0,
			left: 0,
			ease: Quad.easeOut
		};
		var tar  		= Object.assign({}, defaultOptions, options);
		tar.onUpdate 	= self.updateParams;
		TweenMax.to(el.dataContainer, duration, tar);

		var viewportWidth 	= 100,
			viewportHeight 	= 100,
			yScale 			= parseFloat(tar.height)/100,
			xScale 			= parseFloat(tar.width)/100,
			xAxisPosStart	= parseFloat(STATE.DEFAULT.axisX) / 100,
			yAxisPosStart	= parseFloat(STATE.DEFAULT.axisY) / 100,
			xAxisPos		= ( viewportWidth - parseFloat(tar.left) ) - (viewportWidth * xScale) + ( (viewportWidth * xScale) * xAxisPosStart ),
			yAxisPos		= ( viewportHeight - parseFloat(tar.top) ) - (viewportHeight * yScale) + ( (viewportHeight * yScale) * yAxisPosStart );

		// Axis
		TweenMax.to(el.axis.x, duration, {bottom:yAxisPos + '%'});
		TweenMax.to(el.axis.y, duration, {right: xAxisPos + '%'});

		// Labels
		TweenMax.to(el.labels.x, duration, {width:tar.width, left:tar.left});
		TweenMax.to(el.labels.y, duration, {height:tar.height, top:tar.top});

		// Key
		var keyWidth 	= ( 100 / parseFloat(tar.width) ) * 100 + '%',
			keyHeight 	= ( 100 / parseFloat(tar.height) ) * 100 + '%',
			keyLeft		= Math.abs( parseFloat(tar.left) ) / xScale + '%',
			keyTop		= Math.abs( parseFloat(tar.top) ) / yScale + '%';
		TweenMax.to(el.keyHighlight, duration, {width:keyWidth, height:keyHeight, left:keyLeft, top:keyTop});
	}

	self.updateParams = function() {
		params.containerWidth 	= Math.round( el.dataContainer[0].clientWidth );
		params.containerHeight 	= Math.round( el.dataContainer[0].clientHeight );
		params.scaleY 			= parseInt(self.currentState.options.height) / 100 || 1;
		params.scaleX 			= parseInt(self.currentState.options.width) / 100 || 1;
		params.viewportY 		= params.containerHeight / params.scaleY;
		params.viewportX 		= params.containerWidth / params.scaleX;
		params.yRatio 			= 1 - (params.viewportY / params.containerHeight);
		params.xRatio 			= 1 - (params.viewportX / params.containerWidth);
		params.yOffset 			= (parseInt(self.currentState.options.top) / 100) * params.viewportY || 0;
		params.xOffset 			= (parseInt(self.currentState.options.left) / 100) * params.viewportX || 0;
	}

	// Checkbox handling
	self.updateCheckedFunds = function() {

		console.log("TDV :: updateCheckedFunds ::", self.checkedFunds);

		// Fund detail modal style and checking
		var modalCheck = el.fundDetailModal.find('.fund-checkbox input')[0];
		var modalCheckLabel = el.fundDetailModal.find('.fund-checkbox label')[0];
		if (modalCheck) {
			if ( self.isFundChecked( el.fundDetailModal.data('fund') ) ) {
				el.fundDetailModal.addClass('checked');
				if(modalCheck.checked == false) modalCheck.checked = true;
				modalCheckLabel.innerHTML = 'Remove from comparison';
			} else {
				el.fundDetailModal.removeClass('checked');
				if(modalCheck.checked) modalCheck.checked = false;
				modalCheckLabel.innerHTML = 'Add to comparison';
			}
		}
  
		// Analysis modal form update
		if ( el.analysisFunds.length ) {
			var fundString = '';
			for (var i = 0; i < self.checkedFunds.length; i++) {
				fundString += self.getFilteredFundsByID( self.checkedFunds[i] )[ FUND_PARAMS.NAME ];
				if (i+1 < self.checkedFunds.length) {
					fundString += ', ';
				}
			}
			el.analysisFunds[0].value = fundString;
		}

		// Fund list
		el.fundListForm.find('.fund-check').each(function() {
			var fundID = $(this).data('fund'),
				isChecked = self.isFundChecked(fundID),
				checkbox = $(this).find('input')[0];

			if( checkbox.checked != isChecked) checkbox.checked = isChecked;
		});

		// Update selected funds count
		el.attrDataSelectedFunds.attr('data-selected-funds', i);

		if(self.checkedFunds.length) {
			el.requestFundButtons.removeClass('disabled');
			el.requestFundButtons.removeAttr('disabled aria-disabled tabindex');
		} else {
			el.requestFundButtons.addClass('disabled');
			el.requestFundButtons.attr({
				'disabled': 	true,
				'aria-disabled':'true',
				'tabindex': 	'-1'
			});
		}
	}

	self.selectFund = function(id) {
		var checked = false;
		for (var i = 0; i < self.checkedFunds.length; i++) {
			if (self.checkedFunds[i] == id) {
				checked = true;
			}
		}
		if (!checked) {
			self.checkedFunds.push(id);
		}
		el.dataContainer.find('.id-' + id).addClass('selected');
		self.updateCheckedFunds();
	}
	self.deselectFund = function(id) {
		for (var i = 0; i < self.checkedFunds.length; i++) {
			if (self.checkedFunds[i] == id) {
				self.checkedFunds.splice(i,1);
			}
		}
		el.dataContainer.find('.id-' + id).removeClass('selected');
		self.updateCheckedFunds();
	}

	// Return functions
	self.getFilteredFundsByID = function (id) {
		for (var f in self.filteredFunds) {
			if (id == self.filteredFunds[f].ID)
				return self.filteredFunds[f];
		}
	}
	self.getFundsByID = function (id) {
		for (var f in self.csvData) {
			if (id == self.csvData[f].ID)
				return self.csvData[f];
		}
	}
	self.getFundsBySeries = function (series) {
		// console.log("TDV :: getFundsBySeries ::", series);
		var fundArr = [];
		for (var i = 0; i < self.csvSelectionData.length; i++) {
			var fund = self.csvSelectionData[i];
			if (fund.Strategy_Name == series) {
				var year = fund.Description.match(/(20\d{2})/);
				var numYear = year ? Number(year[0]) : undefined;
				fundArr.push({
					fundObj: fund,
					year: numYear
				});
				// console.log("    :: Match :: Description:", fund.Description, ":: Year:", numYear, [year], ":: Data:", [fund]);
			}
		}
		// console.log("    :: Fund Array:", fundArr);
		return fundArr;
	}
	// Returns ID from CSV (first csv object key) of funds that include "Putnam" in the name
	self.getPutnamFunds = function() {
		var putnamFunds = [];
		for (var f in self.csvData) {
			if (self.csvData[f][FUND_PARAMS.NAME].includes('Putnam')) {
				putnamFunds.push(self.csvData[f][ Object.keys(self.csvData[f])[0] ]);
			}
		}
		return putnamFunds;
	}
	self.getSortedFundList = function(getAllFunds) {
		var sortedFunds = [];

		if (getAllFunds) {
			sortedFunds = self.csvData;
		} else {
			for (var f in self.filteredFunds) {
				sortedFunds.push(self.filteredFunds[f]);
			}
		}

		sortedFunds.sort( function(a, b) {
			return ( a[FUND_PARAMS.NAME] > b[FUND_PARAMS.NAME] ) ? 1 : -1;
		});

		return sortedFunds;
	}
	self.getFundCheckbox = function(id) {
		var fund = self.getFilteredFundsByID(id);
		var checked = self.isFundChecked(id) ? 'checked' : '';

		return '<div class="form-check fund-check" data-fund="' + id + '" data-x="' + fund[FUND_PARAMS.X_POSITION] + '" data-y="' + fund[FUND_PARAMS.Y_POSITION] + '">' +
					'<input type="checkbox" id="fund-' + id + '" class="form-check-input" ' + checked + '>' +
					'<label class="form-check-label show-fund-modal" for="fund-' + id + '">' + fund[FUND_PARAMS.NAME] + '</label>' +
				'</div>';
	}
	self.isFundChecked = function(id) {
		var checked = false;
		for (var i = 0; i < self.checkedFunds.length; i++) {
			if ( self.checkedFunds[i] == id )
				checked = true;
		}
		return checked;
	}
	self.getFundSelectDropdown = function(options) {
		var _options = {
			excludeArr: options.excludeArr || [],
			includeIndustryAverage: (options.includeIndustryAverage != undefined) ? options.includeIndustryAverage : false,
			includeAll: (options.includeAll != undefined) ? options.includeAll : false,
			includeOther: (options.includeOther != undefined) ? options.includeOther : false,
		}
		var sortedArr = _options.includeAll ? self.getSortedFundList(true) : self.getSortedFundList();
		var html =	'<select id="fund-dropdown" class="form-control form-control-sm glide-compare my-0" required>';

		if(_options.includeIndustryAverage)
			html +=	'<option value="average" selected>Industry Average</option>';
		else
			html +=	'<option value="" selected>Select fund</option>';

		for (var i = 0; i < sortedArr.length; i++) {
			var excludeFund = false;
			
			for (var j = 0; j < _options.excludeArr.length; j++) {
				excludeFund = (_options.excludeArr[j] == sortedArr[i].ID);
			}
			
			if (sortedArr[i].MISSING_SERIES || sortedArr[i].ID == undefined)
				excludeFund = true;
				
			if (!excludeFund)
				html += '<option value="' + sortedArr[i].ID + '" data-fund-name="' + sortedArr[i][FUND_PARAMS.NAME] + '">' + sortedArr[i][FUND_PARAMS.NAME] + '</option>';
				
			/* if(excludeFund)
				console.log("Exclude fund:", sortedArr[i]); */
		}

		if (_options.includeOther)
			html += 	'<option value="other">Other</option>'
		html += '</select>' +
				'<div class="invalid-feedback">Please select a strategy.</div>';
		return html;
	}
	self.getGlidePathDataFromFund = function(fund) {
		var pointArr = [];
		for (var i = 0; i < FUND_PARAMS.GLIDE_PATH.length; i++) {
			pointArr.push( [ i, Number( fund[ FUND_PARAMS.GLIDE_PATH[i] ] ) ] );
		}
		return pointArr;
	}
	self.getGlidePathKeySymbol = function(symbol, color) {
		switch ( symbol ) {
			case 'triangle':
				symbolHTML = el.svg.triangle; break;
			case 'triangle-down':
				symbolHTML = el.svg.triangleDown; break;
			case 'diamond':
				symbolHTML = el.svg.diamond; break;
			default: // Circle
				symbolHTML = '<span class="symbol ' + symbol + '" style="background-color:' + color + '"></span>';
		}
		return symbolHTML.replace(/fill/g, 'fill="' + color + '"');
	}
	self.getGlidePathSeriesData = function(fund, index, settings) {
		settings = settings || {};
		settings.color = settings.color || FUND_PARAMS.SERIES_COLORS[index];
		settings.zIndex = settings.zIndex != undefined ? settings.zIndex : index;
		return {
			id: index,
			name: fund[FUND_PARAMS.NAME],
			data: self.getGlidePathDataFromFund( fund ),
			color: settings.color,
			zIndex: settings.zIndex,
			showInLegend: false,
			marker: {
				symbol: FUND_PARAMS.SERIES_MARKERS[index]
			}
		};
	}

	function updateManagerSelect(checked) {
		if (checked) {
			el.analysisManagerSelect.show();
			var fundSelectDropdown = self.getFundSelectDropdown({
				includeAll: true,
				includeOther: true
			});
			el.analysisManagerSelect[0].innerHTML = fundSelectDropdown;
			el.analysisManagerSelect[0].firstChild.addEventListener('change', function (e) {
				querySubmit();
				if (this.value) {
					el.analysisManagerSelect[0].firstChild.classList.remove('is-invalid');
				}
				if( this.value === 'other' ) {
					el.strategyOtherModal.modal('show');
				}
			});
		} else {
			el.analysisManagerSelect.hide();
			el.analysisManagerSelect[0].innerHTML = '';
		}
	}
	function addManagerToRequest(fundId) {
		var series = self.getFundsByID(fundId);
		// console.log("TDV :: addManagerToRequest ::", { series: series, fundId: fundId });
		var seriesArr = self.getFundsBySeries(series[FUND_PARAMS.NAME]);
		var script = '';
		for (var j = 0; j < seriesArr.length; j++) {
			var fund = seriesArr[j];
			if (fund.year == undefined || ( fund.year >= requestParams.oldestFundYear && fund.year <= requestParams.youngestFundYear ) ) {
				if (fund.year > requestParams.highestYear) {
					requestParams.highestYear = fund.year;
				}
				if (fund.year < requestParams.lowestYear) {
					requestParams.lowestYear = fund.year;
				}
				var fundObjDescription = fund.fundObj.Description.replace('(', '\\(').replace(')', '\\)');
				script += " ManagersAdd(" + fund.fundObj.db_id + ", " + fund.fundObj.ID + ", " + fundObjDescription + ", GROUP[" + fund.fundObj.Strategy_Name.replace('&reg;', '®') + "]);";
			}
		}
		return script;
	}

	function queryNext(forceEnable) {
		
		forceEnable = (tl.currentLabel() === 'scene-3') ? true : forceEnable;

		var enableNext = true;
		el.answers.each(function (i, el) {
			if (el.value == "" && ($('#question-3').is(":visible") || el.id != "overall")) {
				enableNext = false;
				return;
			}
		});
		if(forceEnable) {
			enableNext = true;
		}
		$([el.nextButton[0], el.nextSubmitButton[0]]).each(function(i, elem) {
			if (tl.currentLabel() !== 'scene-3' && elem == el.nextSubmitButton[0] && (self.checkedFunds.length < self.checkedFundMin)) {
				enableNext = false;
			}
			if (enableNext) {
				elem.disabled = false;
				elem.classList.remove('disabled');
				elem.style.opacity = 1;
			} else {
				elem.disabled = true;
				elem.classList.add('disabled');
				elem.style.opacity = 0.65;
			}
		});
	}

	// Disable fund submit button if form fields and fund requirements are not met
	function querySubmit() {
		var formValid = true;
		var fundDropdown = el.analysisManagerSelect[0].querySelector('select');
		var fundDropdownValue = 0;
		// Check all required form elements
		for (var i = 0; i < el.analysisForm[0].elements.length; i++) {
			var elem = el.analysisForm[0].elements[i];
			if (elem.required) {
				if (!elem.value) {
					formValid = false;
				}
			} 
		}
		// Invalidate if less than two funds selected
		if (fundDropdown && fundDropdown.value) {
			if (fundDropdown.value == 'other' && ( self.checkedFunds.length < self.checkedFundMin ) ) {
				fundDropdownValue = 0;
			} else {
				fundDropdownValue = 1;
			}
		}
		var totalFundsSelected = self.checkedFunds.length + fundDropdownValue;
		if (totalFundsSelected < self.checkedFundMin) {
			formValid = false;
			// Add hover to submit
			$('#submit-wrapper .tt')[0].innerHTML = 'Select at least two strategies';
		} else {
			// Remove hover to submit
			$('#submit-wrapper .tt')[0].innerHTML = 'Email address required';
		}

		formValid ? el.analysisSubmit[0].classList.remove('disabled') : el.analysisSubmit[0].classList.add('disabled');
		el.analysisSubmit[0].disabled = !formValid;

		// console.log('Query Submit', formValid, totalFundsSelected);
	}

	// Animation fade in/out and toggling d-none class
	function hideElement(el, duration) {
		duration = ( duration != undefined ) ? duration : 0.3;
		TweenMax.fromTo(el, duration, { autoAlpha:1 }, { autoAlpha: 0, 
			onComplete: function () {
				if (!el.classList.contains('d-none')) {
					el.classList.add('d-none');
				}
			}
		});
	}
	function showElement(el, duration) {
		duration = ( duration != undefined ) ? duration : 0.3;

		if (el.classList.contains('d-none')) {
			el.classList.remove('d-none');
		}

		TweenMax.fromTo(el, duration, { autoAlpha: 0 }, { autoAlpha: 1 } );
	}

	// Get value from input or return null
	function getVal(value) {
		return value.trim() !== '' ? value : null;
	}

	// Query string parser (Required for IE11)
	function parseQueryString(query) {
		var vars = query.split("&");
		var query_string = {};
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			var key = decodeURIComponent(pair[0]);
			var value = decodeURIComponent(pair[1]);
			if (typeof query_string[key] === "undefined") {
				query_string[key] = decodeURIComponent(value);
			} else if (typeof query_string[key] === "string") {
				var arr = [query_string[key], decodeURIComponent(value)];
				query_string[key] = arr;
			} else {
				query_string[key].push(decodeURIComponent(value));
			}
		}
		return query_string;
	}

	// Returns boolean based on if currently filtered funds has a fund from the self.putnamFundIds array
	Object.defineProperty( self, 'filteredFundsHasPutnam', { get : function(){
		var hasPutnamFund = false;
		for( var i = 0; i < Object.keys(self.filteredFunds).length; i++)
		{
			for( var j = 0; j < self.putnamFundIds.length; j++ )
			{
				if (self.filteredFunds[i][""] === self.putnamFundIds[j] )
					hasPutnamFund = true;
			}
		}

		return hasPutnamFund;
	}});

	// Returns a descriptor of the current selected quadrant: IE: lower right, upper left, etc
	Object.defineProperty( self, 'quadrantDescriptor', { get : function(){
		var quadDesc = "";
		// “You’re currently viewing strategies in the [lower two / two right / upper right / bottom left / bottom right] quadrant[s]. “
		switch( self.currentState.string )
		{
			case "funds-chart-tp":
				quadDesc = "upper two quadrants";
				break;
				
			case "funds-chart-tr":
				quadDesc = "upper right quadrant";
				break;
			
			case "funds-chart-tl":
				quadDesc = "upper left quadrant";
				break;
				
			case "funds-chart-bt":
				quadDesc = "lower two quadrants";
				break;

			case "funds-chart-br":
				quadDesc = "lower right quadrant";
				break;
				
			case "funds-chart-bl":
				quadDesc = "lower left quadrant";
				break;

			case "funds-chart-rt":
				quadDesc = "two right quadrants";
				break;
				
			case "funds-chart-lt":
				quadDesc = "two left quadrants";
				break;
		}
		return quadDesc;
	}});

	ApplicationObject.call( this );
}
TargetDate.prototype = Object.create( ApplicationObject.prototype );